export default [
    {
        "id": 1,
        "netallname": "上海农村商业银行股份有限公司总行营业部",
        "netname": "总行营业部",
        "publicconntel": "021-61899929",
        "postcode": "200002",
        "address": "上海市黄浦区中山东二路70号1-2楼",
        "net_code": "00011",
        "province": "上海市",
        "area": "黄浦区",
        "location": {
            "lng": 121.50100603257694,
            "lat": 31.23613985152826
        }
    },
    {
        "id": 2,
        "netallname": "上海农村商业银行股份有限公司闵行支行",
        "netname": "闵行支行",
        "publicconntel": "021-64889008",
        "postcode": "201199",
        "address": "上海市闵行区七莘路670号1、2层",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.3796050258041,
            "lat": 31.125488237697258
        }
    },
    {
        "id": 3,
        "netallname": "上海农村商业银行股份有限公司纪王分理处",
        "netname": "纪王分理处",
        "publicconntel": "021-62960193",
        "postcode": "201107",
        "address": "上海市闵行区华漕镇纪信路86号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.27911600357444,
            "lat": 31.24814172355951
        }
    },
    {
        "id": 4,
        "netallname": "上海农村商业银行股份有限公司诸翟支行",
        "netname": "诸翟支行",
        "publicconntel": "021-62213011",
        "postcode": "201107",
        "address": "上海市闵行区繁兴路333号107室、215室",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.2999259549846,
            "lat": 31.216829560877063
        }
    },
    {
        "id": 5,
        "netallname": "上海农村商业银行股份有限公司华漕支行",
        "netname": "华漕支行",
        "publicconntel": "021-62204387",
        "postcode": "201106",
        "address": "上海市闵行区北翟路2000弄52、54、56号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.33798846557859,
            "lat": 31.230831110933437
        }
    },
    {
        "id": 6,
        "netallname": "上海农村商业银行股份有限公司七宝支行",
        "netname": "七宝支行",
        "publicconntel": "021-64780206",
        "postcode": "201101",
        "address": "上海市闵行区吴宝路35号一层",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.3562714081315,
            "lat": 31.16381291505127
        }
    },
    {
        "id": 7,
        "netallname": "上海农村商业银行股份有限公司虹桥支行",
        "netname": "虹桥支行",
        "publicconntel": "021-64051126",
        "postcode": "201103",
        "address": "上海市闵行区虹桥镇吴中路1050号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.39420230798522,
            "lat": 31.184165975042955
        }
    },
    {
        "id": 8,
        "netallname": "上海农村商业银行股份有限公司梅陇支行",
        "netname": "梅陇支行",
        "publicconntel": "021-64100345",
        "postcode": "201102",
        "address": "上海市闵行区古美西路429号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.40094609226227,
            "lat": 31.138769771603535
        }
    },
    {
        "id": 9,
        "netallname": "上海农村商业银行股份有限公司颛桥支行",
        "netname": "颛桥支行",
        "publicconntel": "021-64890315",
        "postcode": "201108",
        "address": "上海市闵行区颛桥镇颛兴路269-291号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.40261446098799,
            "lat": 31.071989230018023
        }
    },
    {
        "id": 10,
        "netallname": "上海农村商业银行股份有限公司曹行支行",
        "netname": "曹行支行",
        "publicconntel": "021-64975574",
        "postcode": "201108",
        "address": "上海市闵行区梅陇镇曹建路213号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.44422805431005,
            "lat": 31.09781069690631
        }
    },
    {
        "id": 11,
        "netallname": "上海农村商业银行股份有限公司马桥支行",
        "netname": "马桥支行",
        "publicconntel": "021-64091056",
        "postcode": "201111",
        "address": "上海市闵行区马桥镇西街11号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.37622300347432,
            "lat": 31.033996896455108
        }
    },
    {
        "id": 12,
        "netallname": "上海农村商业银行股份有限公司陈行支行",
        "netname": "陈行支行",
        "publicconntel": "021-34030002",
        "postcode": "201112",
        "address": "上海市闵行区江园路756号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.49924356525112,
            "lat": 31.079476277747958
        }
    },
    {
        "id": 13,
        "netallname": "上海农村商业银行股份有限公司杜行支行",
        "netname": "杜行支行",
        "publicconntel": "021-64110875",
        "postcode": "201112",
        "address": "上海市闵行区浦江镇谈中路229号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.53417376178608,
            "lat": 31.0707119837409
        }
    },
    {
        "id": 14,
        "netallname": "上海农村商业银行股份有限公司鲁汇支行",
        "netname": "鲁汇支行",
        "publicconntel": "021-64911375",
        "postcode": "201112",
        "address": "上海市闵行区浦江镇闸航路2676号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.53938011684383,
            "lat": 31.025775819607492
        }
    },
    {
        "id": 15,
        "netallname": "上海农村商业银行股份有限公司江川支行",
        "netname": "江川支行",
        "publicconntel": "021-54321276",
        "postcode": "200240",
        "address": "上海市闵行区金平路250-254号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.41743280288019,
            "lat": 31.018609448916763
        }
    },
    {
        "id": 16,
        "netallname": "上海农村商业银行股份有限公司吴泾支行",
        "netname": "吴泾支行",
        "publicconntel": "021-54631210",
        "postcode": "200241",
        "address": "上海市闵行区永德路419号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.46217455270371,
            "lat": 31.047081748697234
        }
    },
    {
        "id": 17,
        "netallname": "上海农村商业银行股份有限公司北桥分理处",
        "netname": "北桥分理处",
        "publicconntel": "021-64901715",
        "postcode": "201109",
        "address": "上海市闵行区颛桥镇新建路27号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.41518740381727,
            "lat": 31.04876275748923
        }
    },
    {
        "id": 18,
        "netallname": "上海农村商业银行股份有限公司龙柏分理处",
        "netname": "龙柏分理处",
        "publicconntel": "021-64022271",
        "postcode": "201103",
        "address": "上海市闵行区黄桦路5号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.3719693813591,
            "lat": 31.182428133183112
        }
    },
    {
        "id": 19,
        "netallname": "上海农村商业银行股份有限公司联航分理处",
        "netname": "联航分理处",
        "publicconntel": "021-54325201",
        "postcode": "201112",
        "address": "上海市闵行区联航路1379号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.5277383020109,
            "lat": 31.08316832681601
        }
    },
    {
        "id": 20,
        "netallname": "上海农村商业银行股份有限公司塘湾分理处",
        "netname": "塘湾分理处",
        "publicconntel": "021-34306935",
        "postcode": "201108",
        "address": "上海市闵行区塘湾三星街51号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.44919994534156,
            "lat": 31.06058742480551
        }
    },
    {
        "id": 21,
        "netallname": "上海农村商业银行股份有限公司召稼楼分理处",
        "netname": "召稼楼分理处",
        "publicconntel": "021-34633803",
        "postcode": "201112",
        "address": "上海市闵行区浦江镇沈杜公路2071号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.55502939203143,
            "lat": 31.080910650665793
        }
    },
    {
        "id": 22,
        "netallname": "上海农村商业银行股份有限公司爱博家园支行",
        "netname": "爱博家园支行",
        "publicconntel": "021-34679017",
        "postcode": "201107",
        "address": "上海市闵行区宁虹路1175弄9号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.31541099387411,
            "lat": 31.214506846146367
        }
    },
    {
        "id": 23,
        "netallname": "上海农村商业银行股份有限公司沧源路分理处",
        "netname": "沧源路分理处",
        "publicconntel": "021-54705988",
        "postcode": "200240",
        "address": "上海市闵行区沧源路756号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.4351353295821,
            "lat": 31.020315849943103
        }
    },
    {
        "id": 24,
        "netallname": "上海农村商业银行股份有限公司莘庄工业区支行",
        "netname": "莘庄工业区支行",
        "publicconntel": "021-64885270",
        "postcode": "201199",
        "address": "上海市闵行区莘建路61号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.38543443029239,
            "lat": 31.112609085139596
        }
    },
    {
        "id": 25,
        "netallname": "上海农村商业银行股份有限公司龙吴路分理处",
        "netname": "龙吴路分理处",
        "publicconntel": "021-64509969",
        "postcode": "200241",
        "address": "上海市闵行区龙吴路5572号",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.47505652051353,
            "lat": 31.04770155423355
        }
    },
    {
        "id": 26,
        "netallname": "上海农村商业银行股份有限公司中春路分理处",
        "netname": "中春路分理处",
        "publicconntel": "021-64210756",
        "postcode": "201101",
        "address": "上海市闵行区中春路7001号一层",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.35276466955627,
            "lat": 31.143351021386923
        }
    },
    {
        "id": 27,
        "netallname": "上海农村商业银行股份有限公司虹桥商务区支行",
        "netname": "虹桥商务区支行",
        "publicconntel": "021-54327866",
        "postcode": "201105",
        "address": "上海市闵行区申长路988弄2号1楼106单元",
        "net_code": "31001",
        "province": "上海市",
        "area": "闵行区",
        "location": {
            "lng": 121.320866043914,
            "lat": 31.202401622985185
        }
    },
    {
        "id": 28,
        "netallname": "上海农村商业银行股份有限公司嘉定支行",
        "netname": "嘉定支行",
        "publicconntel": "021-59559103",
        "postcode": "201800",
        "address": "上海市嘉定区塔城路386号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.25464637258443,
            "lat": 31.385694835882774
        }
    },
    {
        "id": 29,
        "netallname": "上海农村商业银行股份有限公司南翔支行",
        "netname": "南翔支行",
        "publicconntel": "021-59122709",
        "postcode": "201802",
        "address": "上海市嘉定区南翔镇解放街201号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.31477379613179,
            "lat": 31.29646430780488
        }
    },
    {
        "id": 30,
        "netallname": "上海农村商业银行股份有限公司封浜支行",
        "netname": "封浜支行",
        "publicconntel": "021-59131882",
        "postcode": "201812",
        "address": "上海市嘉定区翔封路87号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.30121255305126,
            "lat": 31.27636620784125
        }
    },
    {
        "id": 31,
        "netallname": "上海农村商业银行股份有限公司马陆支行",
        "netname": "马陆支行",
        "publicconntel": "021-59168502",
        "postcode": "201801",
        "address": "上海市嘉定区马陆镇宝安公路3308号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.28962300792105,
            "lat": 31.337497556017148
        }
    },
    {
        "id": 32,
        "netallname": "上海农村商业银行股份有限公司戬浜支行",
        "netname": "戬浜支行",
        "publicconntel": "021-59510187",
        "postcode": "201818",
        "address": "上海市嘉定区马陆镇戬浜大治路516号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.29012001071564,
            "lat": 31.33917488274072
        }
    },
    {
        "id": 33,
        "netallname": "上海农村商业银行股份有限公司嘉西支行",
        "netname": "嘉西支行",
        "publicconntel": "021-39972522",
        "postcode": "201800",
        "address": "上海市嘉定区嘉定镇塔城路860号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.24448457806227,
            "lat": 31.377790567376632
        }
    },
    {
        "id": 34,
        "netallname": "上海农村商业银行股份有限公司徐行支行",
        "netname": "徐行支行",
        "publicconntel": "021-39985040",
        "postcode": "201808",
        "address": "上海市嘉定区启源路986、988、990号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.28900399457717,
            "lat": 31.422972438196787
        }
    },
    {
        "id": 35,
        "netallname": "上海农村商业银行股份有限公司曹王分理处",
        "netname": "曹王分理处",
        "publicconntel": "021-59947377",
        "postcode": "201809",
        "address": "上海市嘉定区徐行镇曹王开源路8号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.3117527533797,
            "lat": 31.43789821761225
        }
    },
    {
        "id": 36,
        "netallname": "上海农村商业银行股份有限公司华亭分理处",
        "netname": "华亭分理处",
        "publicconntel": "021-59971303",
        "postcode": "201811",
        "address": "上海市嘉定区华亭镇高石公路966号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.29017220226575,
            "lat": 31.47672873908525
        }
    },
    {
        "id": 37,
        "netallname": "上海农村商业银行股份有限公司娄塘分理处",
        "netname": "娄塘分理处",
        "publicconntel": "021-39932171",
        "postcode": "201807",
        "address": "上海市嘉定区娄塘镇南新路250号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.224101053176,
            "lat": 31.436327140474432
        }
    },
    {
        "id": 38,
        "netallname": "上海农村商业银行股份有限公司唐行支行",
        "netname": "唐行支行",
        "publicconntel": "021-59950527",
        "postcode": "201816",
        "address": "上海市嘉定区华亭镇唐行唐窑路4号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.24607386825528,
            "lat": 31.469044318892077
        }
    },
    {
        "id": 39,
        "netallname": "上海农村商业银行股份有限公司嘉定工业区支行",
        "netname": "嘉定工业区支行",
        "publicconntel": "021-69152723",
        "postcode": "201815",
        "address": "上海市嘉定区汇源路208号1-2层",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.2118633132474,
            "lat": 31.42273989260951
        }
    },
    {
        "id": 40,
        "netallname": "上海农村商业银行股份有限公司外冈支行",
        "netname": "外冈支行",
        "publicconntel": "021-59588701",
        "postcode": "201806",
        "address": "上海市嘉定区外冈镇祁昌路101号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.18117700209426,
            "lat": 31.367265555087098
        }
    },
    {
        "id": 41,
        "netallname": "上海农村商业银行股份有限公司望新分理处",
        "netname": "望新分理处",
        "publicconntel": "021-59939656",
        "postcode": "201823",
        "address": "上海市嘉定区外冈镇外钱路926号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.15693993072283,
            "lat": 31.35491142900515
        }
    },
    {
        "id": 42,
        "netallname": "上海农村商业银行股份有限公司方泰支行",
        "netname": "方泰支行",
        "publicconntel": "021-59506110",
        "postcode": "201814",
        "address": "上海市嘉定区宝安公路4515号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.2248318624372,
            "lat": 31.32267495357681
        }
    },
    {
        "id": 43,
        "netallname": "上海农村商业银行股份有限公司安亭支行",
        "netname": "安亭支行",
        "publicconntel": "021-69915069",
        "postcode": "201805",
        "address": "上海市嘉定区安亭镇墨玉路62号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.16949455869972,
            "lat": 31.29823424742665
        }
    },
    {
        "id": 44,
        "netallname": "上海农村商业银行股份有限公司黄渡支行",
        "netname": "黄渡支行",
        "publicconntel": "021-69581500",
        "postcode": "201804",
        "address": "上海市嘉定区绿苑路595号1-2层、599号1层",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.2178452032994,
            "lat": 31.287375738016973
        }
    },
    {
        "id": 45,
        "netallname": "上海农村商业银行股份有限公司江桥支行",
        "netname": "江桥支行",
        "publicconntel": "021-59140036",
        "postcode": "201803",
        "address": "上海市嘉定区江桥镇虞姬墩路505号110-117室",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.34920650478718,
            "lat": 31.26181411816829
        }
    },
    {
        "id": 46,
        "netallname": "上海农村商业银行股份有限公司福海路分理处",
        "netname": "福海路分理处",
        "publicconntel": "021-69521865",
        "postcode": "201821",
        "address": "上海市嘉定工业区裕民路358号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定工业区",
        "location": {
            "lng": 121.25992894796642,
            "lat": 31.375412434651267
        }
    },
    {
        "id": 47,
        "netallname": "上海农村商业银行股份有限公司新成分理处",
        "netname": "新成分理处",
        "publicconntel": "021-59982811",
        "postcode": "201822",
        "address": "上海市嘉定区新成街道仓场路447号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.27625034970946,
            "lat": 31.387641213395096
        }
    },
    {
        "id": 48,
        "netallname": "上海农村商业银行股份有限公司真新支行",
        "netname": "真新支行",
        "publicconntel": "021-69153193",
        "postcode": "201824",
        "address": "上海市嘉定区丰庄路350-360号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.36997526170327,
            "lat": 31.25204511794195
        }
    },
    {
        "id": 49,
        "netallname": "上海农村商业银行股份有限公司江桥万达分理处",
        "netname": "江桥万达分理处",
        "publicconntel": "021-69515150",
        "postcode": "201803",
        "address": "上海市嘉定区金运路439号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.32654242565187,
            "lat": 31.245615235612515
        }
    },
    {
        "id": 50,
        "netallname": "上海农村商业银行股份有限公司协通支行",
        "netname": "协通支行",
        "publicconntel": "021-59906596",
        "postcode": "201804",
        "address": "上海市嘉定区曹安公路3918号一层",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.28098525966269,
            "lat": 31.277186738035933
        }
    },
    {
        "id": 51,
        "netallname": "上海农村商业银行股份有限公司嘉定工业区南区分理处",
        "netname": "嘉定工业区南区分理处",
        "publicconntel": "021-69952339",
        "postcode": "201821",
        "address": "上海市嘉定区福海路735、737、739号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.24839901977967,
            "lat": 31.370232706232656
        }
    },
    {
        "id": 52,
        "netallname": "上海农村商业银行股份有限公司菊园支行",
        "netname": "菊园支行",
        "publicconntel": "021-59923815",
        "postcode": "201800",
        "address": "上海市嘉定区平城路811号1楼西侧",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.25568317165151,
            "lat": 31.403694115244647
        }
    },
    {
        "id": 53,
        "netallname": "上海农村商业银行股份有限公司西云楼分理处",
        "netname": "西云楼分理处",
        "publicconntel": "021-59168502",
        "postcode": "201800",
        "address": "上海市嘉定区洪德路238号、240号",
        "net_code": "31027",
        "province": "上海市",
        "area": "嘉定区",
        "location": {
            "lng": 121.26635344416523,
            "lat": 31.363719443483124
        }
    },
    {
        "id": 54,
        "netallname": "上海农村商业银行股份有限公司宝山支行",
        "netname": "宝山支行",
        "publicconntel": "021-56675212",
        "postcode": "200940",
        "address": "上海市宝山区牡丹江路1198号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.49648340748692,
            "lat": 31.397142260204465
        }
    },
    {
        "id": 55,
        "netallname": "上海农村商业银行股份有限公司杨行支行",
        "netname": "杨行支行",
        "publicconntel": "021-56801370",
        "postcode": "201901",
        "address": "上海市宝山区杨行镇杨鑫路328号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.44810758787531,
            "lat": 31.374435712963784
        }
    },
    {
        "id": 56,
        "netallname": "上海农村商业银行股份有限公司月浦支行",
        "netname": "月浦支行",
        "publicconntel": "021-56192530",
        "postcode": "200941",
        "address": "上海市宝山区月浦镇四元路151号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.43592991494125,
            "lat": 31.41997205655881
        }
    },
    {
        "id": 57,
        "netallname": "上海农村商业银行股份有限公司盛桥支行",
        "netname": "盛桥支行",
        "publicconntel": "021-56151795",
        "postcode": "200942",
        "address": "上海市宝山区盛桥镇鹤林路78弄2号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.41033538626623,
            "lat": 31.4535587620045
        }
    },
    {
        "id": 58,
        "netallname": "上海农村商业银行股份有限公司罗店支行",
        "netname": "罗店支行",
        "publicconntel": "021-66711968",
        "postcode": "201908",
        "address": "上海市宝山区罗店镇集贤路602-612号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.35720510658663,
            "lat": 31.428596176494043
        }
    },
    {
        "id": 59,
        "netallname": "上海农村商业银行股份有限公司罗泾支行",
        "netname": "罗泾支行",
        "publicconntel": "021-56875700",
        "postcode": "200941",
        "address": "上海市宝山区潘沪路188弄200号、202号、204号、208号。",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.33992826649683,
            "lat": 31.48711847616528
        }
    },
    {
        "id": 60,
        "netallname": "上海农村商业银行股份有限公司顾村支行",
        "netname": "顾村支行",
        "publicconntel": "021-33718742",
        "postcode": "201906",
        "address": "上海市宝山区水产西路1098号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.41605332541361,
            "lat": 31.359279491863678
        }
    },
    {
        "id": 61,
        "netallname": "上海农村商业银行股份有限公司刘行支行",
        "netname": "刘行支行",
        "publicconntel": "021-56023661",
        "postcode": "201907",
        "address": "上海市宝山区顾村镇菊泉街628号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.37971199961746,
            "lat": 31.363171886384745
        }
    },
    {
        "id": 62,
        "netallname": "上海农村商业银行股份有限公司罗南支行",
        "netname": "罗南支行",
        "publicconntel": "021-56011951",
        "postcode": "201908",
        "address": "上海市宝山区罗南镇东太路118号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.37231300477599,
            "lat": 31.391890939236674
        }
    },
    {
        "id": 63,
        "netallname": "上海农村商业银行股份有限公司大场支行",
        "netname": "大场支行",
        "publicconntel": "021-66510656",
        "postcode": "200436",
        "address": "上海市宝山区界华路82-90号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.42897756119258,
            "lat": 31.307505227657852
        }
    },
    {
        "id": 64,
        "netallname": "上海农村商业银行股份有限公司祁连支行",
        "netname": "祁连支行",
        "publicconntel": "021-56130250",
        "postcode": "200444",
        "address": "上海市宝山区聚丰园路588号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.38229697702754,
            "lat": 31.31976230372756
        }
    },
    {
        "id": 65,
        "netallname": "上海农村商业银行股份有限公司庙行支行",
        "netname": "庙行支行",
        "publicconntel": "021-56416577",
        "postcode": "200443",
        "address": "上海市宝山区共康路430号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.44400194901658,
            "lat": 31.3271175268367
        }
    },
    {
        "id": 66,
        "netallname": "上海农村商业银行股份有限公司淞南支行",
        "netname": "淞南支行",
        "publicconntel": "021-36140610",
        "postcode": "200441",
        "address": "上海市宝山区淞南路399号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.49798878426732,
            "lat": 31.35101335405721
        }
    },
    {
        "id": 67,
        "netallname": "上海农村商业银行股份有限公司吴淞支行",
        "netname": "吴淞支行",
        "publicconntel": "021-56178696",
        "postcode": "200940",
        "address": "上海市宝山区淞宝路74号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.50544420616939,
            "lat": 31.384961318038666
        }
    },
    {
        "id": 68,
        "netallname": "上海农村商业银行股份有限公司高境支行",
        "netname": "高境支行",
        "publicconntel": "021-56827617",
        "postcode": "200439",
        "address": "上海市宝山区殷高路65号4幢104、105、106、209室",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.49590727026504,
            "lat": 31.326300012551112
        }
    },
    {
        "id": 69,
        "netallname": "上海农村商业银行股份有限公司市一分理处",
        "netname": "市一分理处",
        "publicconntel": "021-56863671",
        "postcode": "201908",
        "address": "上海市宝山区罗店镇市一路253号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.35038586314207,
            "lat": 31.420303567069414
        }
    },
    {
        "id": 70,
        "netallname": "上海农村商业银行股份有限公司陈行分理处",
        "netname": "陈行分理处",
        "publicconntel": "021-56871037",
        "postcode": "200949",
        "address": "上海市宝山区罗泾镇陈行街66号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.34999763346677,
            "lat": 31.484456931304607
        }
    },
    {
        "id": 71,
        "netallname": "上海农村商业银行股份有限公司共富分理处",
        "netname": "共富分理处",
        "publicconntel": "021-33709892",
        "postcode": "201906",
        "address": "上海市宝山区共富路353号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.43344925325853,
            "lat": 31.355591016791173
        }
    },
    {
        "id": 72,
        "netallname": "上海农村商业银行股份有限公司顾北路分理处",
        "netname": "顾北路分理处",
        "publicconntel": "021-56042879",
        "postcode": "201906",
        "address": "上海市宝山区顾村镇顾北路574、576、578号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.39491788288328,
            "lat": 31.356619768708352
        }
    },
    {
        "id": 73,
        "netallname": "上海农村商业银行股份有限公司大华分理处",
        "netname": "大华分理处",
        "publicconntel": "021-56703326",
        "postcode": "200442",
        "address": "上海市宝山区行知路339号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.42286037914435,
            "lat": 31.28950191432833
        }
    },
    {
        "id": 74,
        "netallname": "上海农村商业银行股份有限公司长江西路分理处",
        "netname": "长江西路分理处",
        "publicconntel": "021-56990943",
        "postcode": "200431",
        "address": "上海市宝山区长江西路1818号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.45275416385455,
            "lat": 31.339167493748963
        }
    },
    {
        "id": 75,
        "netallname": "上海农村商业银行股份有限公司长江南路分理处",
        "netname": "长江南路分理处",
        "publicconntel": "021-66799628",
        "postcode": "200441",
        "address": "上海市宝山区长江南路695-697号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.48549730986268,
            "lat": 31.344227571004954
        }
    },
    {
        "id": 76,
        "netallname": "上海农村商业银行股份有限公司杏林分理处",
        "netname": "杏林分理处",
        "publicconntel": "021-36388653",
        "postcode": "201907",
        "address": "上海市宝山区菊太路1223-1227号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.36312034400919,
            "lat": 31.355297657749414
        }
    },
    {
        "id": 77,
        "netallname": "上海农村商业银行股份有限公司友谊分理处",
        "netname": "友谊分理处",
        "publicconntel": "021-66750591",
        "postcode": "201901",
        "address": "上海市宝山区友谊路1913-1917号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.45445885216996,
            "lat": 31.39814139933045
        }
    },
    {
        "id": 78,
        "netallname": "上海农村商业银行股份有限公司杨泰路分理处",
        "netname": "杨泰路分理处",
        "publicconntel": "021-66037679",
        "postcode": "201901",
        "address": "上海市宝山区镇新路184、188号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.44628451142758,
            "lat": 31.385649533564127
        }
    },
    {
        "id": 79,
        "netallname": "上海农村商业银行股份有限公司美安路分理处",
        "netname": "美安路分理处",
        "publicconntel": "021-56451591",
        "postcode": "201907",
        "address": "上海市宝山区美安路211号",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.35659767269274,
            "lat": 31.394195655092847
        }
    },
    {
        "id": 80,
        "netallname": "上海农村商业银行股份有限公司四元路分理处",
        "netname": "四元路分理处",
        "publicconntel": "021-66930021",
        "postcode": "200941",
        "address": "上海市宝山区月浦镇四元路151号一层",
        "net_code": "31051",
        "province": "上海市",
        "area": "宝山区",
        "location": {
            "lng": 121.43592991494125,
            "lat": 31.41997205655881
        }
    },
    {
        "id": 81,
        "netallname": "上海农村商业银行股份有限公司上海自贸试验区临港新片区支行",
        "netname": "上海自贸试验区临港新片区支行",
        "publicconntel": "021-20785306",
        "postcode": "201306",
        "address": "上海市浦东新区申港大道162号一层、云鹃路628-2号二层",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.93005955481424,
            "lat": 30.904368642575307
        }
    },
    {
        "id": 82,
        "netallname": "上海农村商业银行股份有限公司南汇支行",
        "netname": "南汇支行",
        "publicconntel": "021-58012266",
        "postcode": "201399",
        "address": "上海市浦东新区惠南镇东门大街487号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.76263490727206,
            "lat": 31.052126447133336
        }
    },
    {
        "id": 83,
        "netallname": "上海农村商业银行股份有限公司惠南支行",
        "netname": "惠南支行",
        "publicconntel": "021-58006505",
        "postcode": "201399",
        "address": "上海市浦东新区惠南镇惠东路28号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.77066212039395,
            "lat": 31.050518925518958
        }
    },
    {
        "id": 84,
        "netallname": "上海农村商业银行股份有限公司周浦支行",
        "netname": "周浦支行",
        "publicconntel": "021-68115681",
        "postcode": "201318",
        "address": "上海市浦东新区周浦镇周东路199号1-3层",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.593244875969,
            "lat": 31.121335372158747
        }
    },
    {
        "id": 85,
        "netallname": "上海农村商业银行股份有限公司康桥支行",
        "netname": "康桥支行",
        "publicconntel": "021-68123175",
        "postcode": "201318",
        "address": "上海市浦东新区康桥镇康沈路1348号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.58124224055848,
            "lat": 31.129038211411334
        }
    },
    {
        "id": 86,
        "netallname": "上海农村商业银行股份有限公司大团支行",
        "netname": "大团支行",
        "publicconntel": "021-58081105",
        "postcode": "201311",
        "address": "上海市南汇区大团镇永春东路29号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.75134372174068,
            "lat": 30.976959332031118
        }
    },
    {
        "id": 87,
        "netallname": "上海农村商业银行股份有限公司新场支行",
        "netname": "新场支行",
        "publicconntel": "021-58171627",
        "postcode": "201314",
        "address": "上海市浦东新区新场镇新奉公路339号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.64987752906542,
            "lat": 31.030074255276936
        }
    },
    {
        "id": 88,
        "netallname": "上海农村商业银行股份有限公司祝桥支行",
        "netname": "祝桥支行",
        "publicconntel": "021-58107268",
        "postcode": "201323",
        "address": "上海市浦东新区祝桥镇百熙路368弄23-25号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.76843355916951,
            "lat": 31.11943498907101
        }
    },
    {
        "id": 89,
        "netallname": "上海农村商业银行股份有限公司泥城支行",
        "netname": "泥城支行",
        "publicconntel": "021-58072583",
        "postcode": "201306",
        "address": "上海市浦东新区泥城镇鸿音路3388弄3号119、120",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.82383664132794,
            "lat": 30.912746204681543
        }
    },
    {
        "id": 90,
        "netallname": "上海农村商业银行股份有限公司下沙支行",
        "netname": "下沙支行",
        "publicconntel": "021-58148000",
        "postcode": "201317",
        "address": "上海市浦东新区航头镇下沙新街91号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.599628985008,
            "lat": 31.056596950540214
        }
    },
    {
        "id": 91,
        "netallname": "上海农村商业银行股份有限公司老港支行",
        "netname": "老港支行",
        "publicconntel": "021-58055400",
        "postcode": "201302",
        "address": "上海市浦东新区中港镇鑫盛路11号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.84622853389374,
            "lat": 31.045757815452486
        }
    },
    {
        "id": 92,
        "netallname": "上海农村商业银行股份有限公司万祥支行",
        "netname": "万祥支行",
        "publicconntel": "021-58048787",
        "postcode": "201313",
        "address": "上海市浦东新区万祥镇万和路36号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.82148484246892,
            "lat": 30.972666280601864
        }
    },
    {
        "id": 93,
        "netallname": "上海农村商业银行股份有限公司六灶支行",
        "netname": "六灶支行",
        "publicconntel": "021-58162454",
        "postcode": "201322",
        "address": "上海市浦东新区六灶镇周祝公路2338号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.7040734934321,
            "lat": 31.12232592069875
        }
    },
    {
        "id": 94,
        "netallname": "上海农村商业银行股份有限公司黄路支行",
        "netname": "黄路支行",
        "publicconntel": "021-58270079",
        "postcode": "201301",
        "address": "上海市浦东新区惠南镇黄路社区黄家路85号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.78462878851383,
            "lat": 31.0314704641339
        }
    },
    {
        "id": 95,
        "netallname": "上海农村商业银行股份有限公司三灶支行",
        "netname": "三灶支行",
        "publicconntel": "021-58036760",
        "postcode": "201399",
        "address": "上海市浦东新区宣桥镇三灶社区南六公路636号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.71987597821764,
            "lat": 31.07513310376196
        }
    },
    {
        "id": 96,
        "netallname": "上海农村商业银行股份有限公司横沔支行",
        "netname": "横沔支行",
        "publicconntel": "021-58131437",
        "postcode": "201319",
        "address": "上海市浦东新区秀沿路2581号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.6119344014771,
            "lat": 31.143519975692268
        }
    },
    {
        "id": 97,
        "netallname": "上海农村商业银行股份有限公司三墩支行",
        "netname": "三墩支行",
        "publicconntel": "021-58231389",
        "postcode": "201312",
        "address": "上海市浦东新区大团镇三墩社区三宣公路323号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.76473338667219,
            "lat": 30.996432556860228
        }
    },
    {
        "id": 98,
        "netallname": "上海农村商业银行股份有限公司坦直支行",
        "netname": "坦直支行",
        "publicconntel": "021-68151199",
        "postcode": "201321",
        "address": "上海市浦东新区新场镇坦直社区古恩路64－66号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.65587399232771,
            "lat": 31.078817849456083
        }
    },
    {
        "id": 99,
        "netallname": "上海农村商业银行股份有限公司盐仓支行",
        "netname": "盐仓支行",
        "publicconntel": "021-58098787",
        "postcode": "201324",
        "address": "上海市浦东新区盐仓镇浦红东路10号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.76950099225108,
            "lat": 31.093340116002928
        }
    },
    {
        "id": 100,
        "netallname": "上海农村商业银行股份有限公司民乐支行",
        "netname": "民乐支行",
        "publicconntel": "021-58240135",
        "postcode": "201399",
        "address": "浦东新区惠南镇听悦路1167全幢、1169-1171号底层",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.74488235213968,
            "lat": 31.069067903719095
        }
    },
    {
        "id": 101,
        "netallname": "上海农村商业银行股份有限公司航头支行",
        "netname": "航头支行",
        "publicconntel": "021-58222145",
        "postcode": "201316",
        "address": "上海市浦东新区航头镇航头路1059－1065号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.60144482695232,
            "lat": 31.038938486382474
        }
    },
    {
        "id": 102,
        "netallname": "上海农村商业银行股份有限公司新港支行",
        "netname": "新港支行",
        "publicconntel": "021-58196145",
        "postcode": "201304",
        "address": "上海市浦东新区书院镇新港社区南果公路709号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.87448063743697,
            "lat": 30.991648176847626
        }
    },
    {
        "id": 103,
        "netallname": "上海农村商业银行股份有限公司书院支行",
        "netname": "书院支行",
        "publicconntel": "021-58061839",
        "postcode": "201305",
        "address": "上海市浦东新区书院镇老芦公路1408号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.87285032522455,
            "lat": 30.931574327996437
        }
    },
    {
        "id": 104,
        "netallname": "上海农村商业银行股份有限公司瓦屑支行",
        "netname": "瓦屑支行",
        "publicconntel": "021-58152356",
        "postcode": "201321",
        "address": "上海市浦东新区周浦镇瓦屑社区振兴路88号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.65984671969981,
            "lat": 31.114801276287515
        }
    },
    {
        "id": 105,
        "netallname": "上海农村商业银行股份有限公司宣桥支行",
        "netname": "宣桥支行",
        "publicconntel": "021-58181290",
        "postcode": "201314",
        "address": "上海市浦东新区宣桥镇宣黄公路153号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.70715455107704,
            "lat": 31.03287626673005
        }
    },
    {
        "id": 106,
        "netallname": "上海农村商业银行股份有限公司芦潮港支行",
        "netname": "芦潮港支行",
        "publicconntel": "021-58282156",
        "postcode": "201308",
        "address": "上海市浦东新区芦潮港渔港路63号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.85543654086273,
            "lat": 30.882611698025357
        }
    },
    {
        "id": 107,
        "netallname": "上海农村商业银行股份有限公司南汇人民东路分理处",
        "netname": "南汇人民东路分理处",
        "publicconntel": "021-68245097",
        "postcode": "201399",
        "address": "上海市浦东新区人民东路2575号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.77932456127415,
            "lat": 31.05505979121757
        }
    },
    {
        "id": 108,
        "netallname": "上海农村商业银行股份有限公司康沈路分理处",
        "netname": "康沈路分理处",
        "publicconntel": "021-58113134",
        "postcode": "201318",
        "address": "上海市浦东新区康沈路1581号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.58285440160978,
            "lat": 31.123181055714785
        }
    },
    {
        "id": 109,
        "netallname": "上海农村商业银行股份有限公司鹤驰路分理处",
        "netname": "鹤驰路分理处",
        "publicconntel": "021-20926678",
        "postcode": "201317",
        "address": "上海市浦东新区航头镇鹤驰路82-86号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.60085018823015,
            "lat": 31.085188499760612
        }
    },
    {
        "id": 110,
        "netallname": "上海农村商业银行股份有限公司泥城新城路分理处",
        "netname": "泥城新城路分理处",
        "publicconntel": "021-20960937",
        "postcode": "201306",
        "address": "上海市浦东新区泥城镇新城路8号",
        "net_code": "31078",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.83329189610889,
            "lat": 30.908719925178616
        }
    },
    {
        "id": 111,
        "netallname": "上海农村商业银行股份有限公司奉贤支行",
        "netname": "奉贤支行",
        "publicconntel": "021-57106246",
        "postcode": "201400",
        "address": "上海市奉贤区望园南路2251、2259、2263、2267号，展园路399、407号",
        "net_code": "31111",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.46478643975367,
            "lat": 30.917065925866535
        }
    },
    {
        "id": 112,
        "netallname": "上海农村商业银行股份有限公司奉城支行",
        "netname": "奉城支行",
        "publicconntel": "021-57522214",
        "postcode": "201411",
        "address": "上海市奉贤区奉城镇川南奉公路9851号—9857号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.65345671687835,
            "lat": 30.916360030833914
        }
    },
    {
        "id": 113,
        "netallname": "上海农村商业银行股份有限公司庄行支行",
        "netname": "庄行支行",
        "publicconntel": "021-57468791",
        "postcode": "201415",
        "address": "上海市奉贤区庄行镇南亭公路2912号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.40529136130225,
            "lat": 30.909426844762432
        }
    },
    {
        "id": 114,
        "netallname": "上海农村商业银行股份有限公司泰日支行",
        "netname": "泰日支行",
        "publicconntel": "021-57586076",
        "postcode": "201405",
        "address": "上海市奉贤区金汇镇大叶公路6768号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.57600072462532,
            "lat": 30.985310720037212
        }
    },
    {
        "id": 115,
        "netallname": "上海农村商业银行股份有限公司青村支行",
        "netname": "青村支行",
        "publicconntel": "021-57566259",
        "postcode": "201414",
        "address": "上海市奉贤区青村镇南奉公路2789号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.58851922395236,
            "lat": 30.929725409176726
        }
    },
    {
        "id": 116,
        "netallname": "上海农村商业银行股份有限公司肖塘支行",
        "netname": "肖塘支行",
        "publicconntel": "021-57433045",
        "postcode": "201401",
        "address": "上海市奉贤区南桥镇沪杭公路356、358号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.44025406661532,
            "lat": 30.92887141944809
        }
    },
    {
        "id": 117,
        "netallname": "上海农村商业银行股份有限公司新寺支行",
        "netname": "新寺支行",
        "publicconntel": "021-57492692",
        "postcode": "201417",
        "address": "上海市奉贤区柘林镇新寺社区新北路61号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.46610704676863,
            "lat": 30.870858275853365
        }
    },
    {
        "id": 118,
        "netallname": "上海农村商业银行股份有限公司齐贤支行",
        "netname": "齐贤支行",
        "publicconntel": "021-57575371",
        "postcode": "201403",
        "address": "上海市奉贤区嘉园路270号1-2层",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.5017241505779,
            "lat": 30.964303455517587
        }
    },
    {
        "id": 119,
        "netallname": "上海农村商业银行股份有限公司光明支行",
        "netname": "光明支行",
        "publicconntel": "021-57471161",
        "postcode": "201406",
        "address": "上海市奉贤区南桥镇光明路506号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.51644535759735,
            "lat": 30.910984575287703
        }
    },
    {
        "id": 120,
        "netallname": "上海农村商业银行股份有限公司四团支行",
        "netname": "四团支行",
        "publicconntel": "021-57532237",
        "postcode": "201412",
        "address": "上海市奉贤区四团镇四新街58号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.7259848994484,
            "lat": 30.945504627381748
        }
    },
    {
        "id": 121,
        "netallname": "上海农村商业银行股份有限公司钱桥支行",
        "netname": "钱桥支行",
        "publicconntel": "021-57596185",
        "postcode": "201407",
        "address": "上海市奉贤区青村镇钱桥社区振水路17号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.54764701314699,
            "lat": 30.87925827977044
        }
    },
    {
        "id": 122,
        "netallname": "上海农村商业银行股份有限公司邬桥支行",
        "netname": "邬桥支行",
        "publicconntel": "021-57401161",
        "postcode": "201402",
        "address": "上海市奉贤区庄行镇大叶公路2599号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.40725898543705,
            "lat": 30.963686429903774
        }
    },
    {
        "id": 123,
        "netallname": "上海农村商业银行股份有限公司平安支行",
        "netname": "平安支行",
        "publicconntel": "021-57541174",
        "postcode": "201413",
        "address": "上海市奉贤区四团镇平福路1275号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.73658200024444,
            "lat": 30.90368384590484
        }
    },
    {
        "id": 124,
        "netallname": "上海农村商业银行股份有限公司头桥支行",
        "netname": "头桥支行",
        "publicconntel": "021-57551172",
        "postcode": "201409",
        "address": "上海市奉贤区奉城镇头桥东路622号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.65198266221446,
            "lat": 30.952527189254035
        }
    },
    {
        "id": 125,
        "netallname": "上海农村商业银行股份有限公司金汇支行",
        "netname": "金汇支行",
        "publicconntel": "021-57481163",
        "postcode": "201404",
        "address": "上海市奉贤区金汇镇西街1号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.50330178705353,
            "lat": 30.992144779070575
        }
    },
    {
        "id": 126,
        "netallname": "上海农村商业银行股份有限公司塘外支行",
        "netname": "塘外支行",
        "publicconntel": "021-57170347",
        "postcode": "201408",
        "address": "上海市奉贤区奉城镇塘外镇人民路78号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.40348531178631,
            "lat": 31.628577101689935
        }
    },
    {
        "id": 127,
        "netallname": "上海农村商业银行股份有限公司江海支行",
        "netname": "江海支行",
        "publicconntel": "021-37590275",
        "postcode": "201400",
        "address": "上海市奉贤区航南公路6120号一层",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.55109514447416,
            "lat": 30.876117699393003
        }
    },
    {
        "id": 128,
        "netallname": "上海农村商业银行股份有限公司柘林支行",
        "netname": "柘林支行",
        "publicconntel": "021-57445155",
        "postcode": "201424",
        "address": "上海市奉贤区柘林镇新柘中路111号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.48178802675088,
            "lat": 30.83607632133982
        }
    },
    {
        "id": 129,
        "netallname": "上海农村商业银行股份有限公司洪庙支行",
        "netname": "洪庙支行",
        "publicconntel": "021-57132830",
        "postcode": "201413",
        "address": "上海市奉贤区奉城镇洪庙水闸路12号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.68790390711686,
            "lat": 30.931045691200712
        }
    },
    {
        "id": 130,
        "netallname": "上海农村商业银行股份有限公司育秀分理处",
        "netname": "育秀分理处",
        "publicconntel": "021-57104717",
        "postcode": "201400",
        "address": "上海市奉贤区南桥镇江海路232号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.46530022109857,
            "lat": 30.91230956431731
        }
    },
    {
        "id": 131,
        "netallname": "上海农村商业银行股份有限公司南桥分理处",
        "netname": "南桥分理处",
        "publicconntel": "021-57104107",
        "postcode": "201400",
        "address": "上海市奉贤区南桥镇环城东路1468号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.47619672083293,
            "lat": 30.918402317160027
        }
    },
    {
        "id": 132,
        "netallname": "上海农村商业银行股份有限公司贝港分理处",
        "netname": "贝港分理处",
        "publicconntel": "021-57102837",
        "postcode": "201400",
        "address": "上海市奉贤区南桥镇解放西路356路",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.46549799203964,
            "lat": 30.908965851135303
        }
    },
    {
        "id": 133,
        "netallname": "上海农村商业银行股份有限公司杨王支行",
        "netname": "杨王支行",
        "publicconntel": "021-33617753",
        "postcode": "201400",
        "address": "上海市奉贤区金海公路3111号一楼",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.50447897150909,
            "lat": 30.907965838935162
        }
    },
    {
        "id": 134,
        "netallname": "上海农村商业银行股份有限公司南桥新城支行",
        "netname": "南桥新城支行",
        "publicconntel": "021-37530115",
        "postcode": "201400",
        "address": "上海市奉贤区望园路1529弄2幢2号101室",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.48368232759674,
            "lat": 30.953523726540475
        }
    },
    {
        "id": 135,
        "netallname": "上海农村商业银行股份有限公司海湾分理处",
        "netname": "海湾分理处",
        "publicconntel": "021-57501025",
        "postcode": "201419",
        "address": "上海市奉贤区海湾镇海农公路1488号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.573219,
            "lat": 30.865384
        }
    },
    {
        "id": 136,
        "netallname": "上海农村商业银行股份有限公司南中路分理处",
        "netname": "南中路分理处",
        "publicconntel": "021-57420938",
        "postcode": "201400",
        "address": "上海市奉贤区南桥镇南中路90号",
        "net_code": "31109",
        "province": "上海市",
        "area": "奉贤区",
        "location": {
            "lng": 121.4653730377432,
            "lat": 30.919739131921823
        }
    },
    {
        "id": 137,
        "netallname": "上海农村商业银行股份有限公司松江支行",
        "netname": "松江支行",
        "publicconntel": "021-57818067",
        "postcode": "201600",
        "address": "上海市松江区人民北路405号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.23254316396887,
            "lat": 31.02398910596084
        }
    },
    {
        "id": 138,
        "netallname": "上海农村商业银行股份有限公司永丰支行",
        "netname": "永丰支行",
        "publicconntel": "021-57820798",
        "postcode": "201600",
        "address": "上海市松江区玉树路2472号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.21569653736704,
            "lat": 31.014416657713973
        }
    },
    {
        "id": 139,
        "netallname": "上海农村商业银行股份有限公司中山支行",
        "netname": "中山支行",
        "publicconntel": "021-37628412",
        "postcode": "201613",
        "address": "上海市松江区茸梅路189-193号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.25289206546587,
            "lat": 31.03955503638916
        }
    },
    {
        "id": 140,
        "netallname": "上海农村商业银行股份有限公司车墩支行",
        "netname": "车墩支行",
        "publicconntel": "021-57601454",
        "postcode": "201611",
        "address": "上海市松江区车墩镇虬长路181号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.31644203120962,
            "lat": 31.021310232240435
        }
    },
    {
        "id": 141,
        "netallname": "上海农村商业银行股份有限公司新桥支行",
        "netname": "新桥支行",
        "publicconntel": "021-57642146",
        "postcode": "201612",
        "address": "上海市松江区新桥镇新镇街925号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.32032264813134,
            "lat": 31.07001855469777
        }
    },
    {
        "id": 142,
        "netallname": "上海农村商业银行股份有限公司洞泾支行",
        "netname": "洞泾支行",
        "publicconntel": "021-57673004",
        "postcode": "201619",
        "address": "上海市松江区洞泾镇长兴路615号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.2740570002644,
            "lat": 31.086943851278583
        }
    },
    {
        "id": 143,
        "netallname": "上海农村商业银行股份有限公司九亭支行",
        "netname": "九亭支行",
        "publicconntel": "021-57631512",
        "postcode": "201615",
        "address": "上海市松江区九亭镇九亭大街378号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.33804642604669,
            "lat": 31.13673040388597
        }
    },
    {
        "id": 144,
        "netallname": "上海农村商业银行股份有限公司泗泾支行",
        "netname": "泗泾支行",
        "publicconntel": "021-57612112",
        "postcode": "201601",
        "address": "上海市松江区泗泾镇鼓浪路800、802、804号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.27428215694727,
            "lat": 31.120132777451193
        }
    },
    {
        "id": 145,
        "netallname": "上海农村商业银行股份有限公司佘山支行",
        "netname": "佘山支行",
        "publicconntel": "021-57651226",
        "postcode": "201602",
        "address": "上海市松江区佘山镇桃源路150号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.19376417118826,
            "lat": 31.10612365252054
        }
    },
    {
        "id": 146,
        "netallname": "上海农村商业银行股份有限公司天马山支行",
        "netname": "天马山支行",
        "publicconntel": "021-57660552",
        "postcode": "201603",
        "address": "上海市松江区天马山镇天新路91号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.15172482976263,
            "lat": 31.07480755276174
        }
    },
    {
        "id": 147,
        "netallname": "上海农村商业银行股份有限公司小昆山支行",
        "netname": "小昆山支行",
        "publicconntel": "021-57761113",
        "postcode": "201616",
        "address": "上海市松江区科技园区小昆山平原街191号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.14403565259737,
            "lat": 31.03926026763613
        }
    },
    {
        "id": 148,
        "netallname": "上海农村商业银行股份有限公司大港支行",
        "netname": "大港支行",
        "publicconntel": "021-57853662",
        "postcode": "201614",
        "address": "上海市松江区科技园区大港新港路127号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.15543336278932,
            "lat": 31.012277215583513
        }
    },
    {
        "id": 149,
        "netallname": "上海农村商业银行股份有限公司李塔汇支行",
        "netname": "李塔汇支行",
        "publicconntel": "021-57841828",
        "postcode": "201617",
        "address": "上海市松江区唐明路855弄190-193号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.1885959474028,
            "lat": 30.977834533302886
        }
    },
    {
        "id": 150,
        "netallname": "上海农村商业银行股份有限公司石湖荡支行",
        "netname": "石湖荡支行",
        "publicconntel": "021-57752654",
        "postcode": "201614",
        "address": "上海市松江区石湖荡镇石湖新路36—38号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.12688407283423,
            "lat": 30.990427635321918
        }
    },
    {
        "id": 151,
        "netallname": "上海农村商业银行股份有限公司新浜支行",
        "netname": "新浜支行",
        "publicconntel": "021-57893275",
        "postcode": "201605",
        "address": "上海市松江区新浜镇叶新公路6291号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.07330913042253,
            "lat": 30.93975603543874
        }
    },
    {
        "id": 152,
        "netallname": "上海农村商业银行股份有限公司五厍支行",
        "netname": "五厍支行",
        "publicconntel": "021-57878162",
        "postcode": "201606",
        "address": "上海市松江区泖港镇北厍路50号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.14690064486034,
            "lat": 30.94723755887927
        }
    },
    {
        "id": 153,
        "netallname": "上海农村商业银行股份有限公司泖港支行",
        "netname": "泖港支行",
        "publicconntel": "021-57863514",
        "postcode": "201607",
        "address": "上海市松江区泖港镇新宾路215号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.22301485539064,
            "lat": 30.93888464981465
        }
    },
    {
        "id": 154,
        "netallname": "上海农村商业银行股份有限公司张泽支行",
        "netname": "张泽支行",
        "publicconntel": "021-57881105",
        "postcode": "201608",
        "address": "上海市松江区叶榭镇辕门路172号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.28235042263094,
            "lat": 30.93566030215766
        }
    },
    {
        "id": 155,
        "netallname": "上海农村商业银行股份有限公司叶榭支行",
        "netname": "叶榭支行",
        "publicconntel": "021-57801486",
        "postcode": "201609",
        "address": "上海市松江区叶榭镇叶新公路36-42号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.33340387357785,
            "lat": 30.95570599354771
        }
    },
    {
        "id": 156,
        "netallname": "上海农村商业银行股份有限公司松江工业区支行",
        "netname": "松江工业区支行",
        "publicconntel": "021-67742530",
        "postcode": "201600",
        "address": "上海市松江区荣乐东路2033号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.26061140773015,
            "lat": 31.02280450833434
        }
    },
    {
        "id": 157,
        "netallname": "上海农村商业银行股份有限公司中山中路分理处",
        "netname": "中山中路分理处",
        "publicconntel": "021-57714104",
        "postcode": "201600",
        "address": "上海市松江区中山中路187—191号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.23762721293484,
            "lat": 31.01245900996747
        }
    },
    {
        "id": 158,
        "netallname": "上海农村商业银行股份有限公司松江新城区支行",
        "netname": "松江新城区支行",
        "publicconntel": "021-57757140",
        "postcode": "201620",
        "address": "上海市松江区新松江路1451号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.21441602262529,
            "lat": 31.044852116482023
        }
    },
    {
        "id": 159,
        "netallname": "上海农村商业银行股份有限公司谷阳路分理处",
        "netname": "谷阳路分理处",
        "publicconntel": "021-57821340",
        "postcode": "201600",
        "address": "上海市松江区乐都路166号",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.24316510201395,
            "lat": 31.019732703163918
        }
    },
    {
        "id": 160,
        "netallname": "上海农村商业银行股份有限公司梅家浜路分理处",
        "netname": "梅家浜路分理处",
        "publicconntel": "021-67822867",
        "postcode": "201600",
        "address": "上海市松江区梅家浜路1507号一楼东侧、1567弄60、62号一楼",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.23590448844138,
            "lat": 31.05800894152643
        }
    },
    {
        "id": 161,
        "netallname": "上海农村商业银行股份有限公司泰晤士小镇分理处",
        "netname": "泰晤士小镇分理处",
        "publicconntel": "021-57728407",
        "postcode": "201600",
        "address": "上海市松江区文诚路1480号1楼113-118室",
        "net_code": "31135",
        "province": "上海市",
        "area": "松江区",
        "location": {
            "lng": 121.20323275772128,
            "lat": 31.0360300778669
        }
    },
    {
        "id": 162,
        "netallname": "上海农村商业银行股份有限公司金山支行",
        "netname": "金山支行",
        "publicconntel": "021-57961217",
        "postcode": "200540",
        "address": "上海市金山区卫清西路505号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.34982898559032,
            "lat": 30.73486686517375
        }
    },
    {
        "id": 163,
        "netallname": "上海农村商业银行股份有限公司万安街支行",
        "netname": "万安街支行",
        "publicconntel": "021-57335153",
        "postcode": "201599",
        "address": "上海市金山区朱泾镇万安街528号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.1752407495554,
            "lat": 30.9031227955339
        }
    },
    {
        "id": 164,
        "netallname": "上海农村商业银行股份有限公司枫泾支行",
        "netname": "枫泾支行",
        "publicconntel": "021-57351306",
        "postcode": "201501",
        "address": "上海市金山区枫泾镇泾波路351号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.02207462600008,
            "lat": 30.9011480743194
        }
    },
    {
        "id": 165,
        "netallname": "上海农村商业银行股份有限公司兴塔支行",
        "netname": "兴塔支行",
        "publicconntel": "021-57361064",
        "postcode": "201502",
        "address": "上海市金山区新金山路210号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.08528461005749,
            "lat": 30.875471373260456
        }
    },
    {
        "id": 166,
        "netallname": "上海农村商业银行股份有限公司新农支行",
        "netname": "新农支行",
        "publicconntel": "021-57340424",
        "postcode": "201503",
        "address": "上海市金山区朱泾镇浦银路388号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.21350422995637,
            "lat": 30.898412950960747
        }
    },
    {
        "id": 167,
        "netallname": "上海农村商业银行股份有限公司松隐支行",
        "netname": "松隐支行",
        "publicconntel": "021-57381027",
        "postcode": "201504",
        "address": "上海市金山区亭林镇小康路55号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.24685374745496,
            "lat": 30.9002320631271
        }
    },
    {
        "id": 168,
        "netallname": "上海农村商业银行股份有限公司亭林支行",
        "netname": "亭林支行",
        "publicconntel": "021-57232344",
        "postcode": "201505",
        "address": "上海市金山区亭林镇寺平北路61号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.32035200026388,
            "lat": 30.889445846332432
        }
    },
    {
        "id": 169,
        "netallname": "上海农村商业银行股份有限公司金山工业区支行",
        "netname": "金山工业区支行",
        "publicconntel": "021-57270775",
        "postcode": "201506",
        "address": "上海市金山区亭林镇开乐大街1号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.3509489183408,
            "lat": 30.855007396349887
        }
    },
    {
        "id": 170,
        "netallname": "上海农村商业银行股份有限公司漕泾支行",
        "netname": "漕泾支行",
        "publicconntel": "021-57253448",
        "postcode": "201507",
        "address": "上海市金山区漕泾镇中一东路385号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.4240524808612,
            "lat": 30.800763007855835
        }
    },
    {
        "id": 171,
        "netallname": "上海农村商业银行股份有限公司山阳支行",
        "netname": "山阳支行",
        "publicconntel": "021-57241031",
        "postcode": "201508",
        "address": "上海市金山区龙皓路488号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.35434022555633,
            "lat": 30.764136553033225
        }
    },
    {
        "id": 172,
        "netallname": "上海农村商业银行股份有限公司金卫支行",
        "netname": "金卫支行",
        "publicconntel": "021-57260511",
        "postcode": "201512",
        "address": "上海市金山区北泰路218号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.32491046235393,
            "lat": 30.736484521904146
        }
    },
    {
        "id": 173,
        "netallname": "上海农村商业银行股份有限公司张堰支行",
        "netname": "张堰支行",
        "publicconntel": "021-57213593",
        "postcode": "201514",
        "address": "上海市金山区张堰镇金张公路198号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.29426200040514,
            "lat": 30.812912850901416
        }
    },
    {
        "id": 174,
        "netallname": "上海农村商业银行股份有限公司钱圩支行",
        "netname": "钱圩支行",
        "publicconntel": "021-57291074",
        "postcode": "201515",
        "address": "上海市金山区金山卫镇建圩路81号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.25461547356981,
            "lat": 30.78126177013824
        }
    },
    {
        "id": 175,
        "netallname": "上海农村商业银行股份有限公司廊下支行",
        "netname": "廊下支行",
        "publicconntel": "021-57391052",
        "postcode": "201516",
        "address": "上海市金山区廊下镇益民路98号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.19822004678909,
            "lat": 30.79417740441657
        }
    },
    {
        "id": 176,
        "netallname": "上海农村商业银行股份有限公司吕巷支行",
        "netname": "吕巷支行",
        "publicconntel": "021-57371508",
        "postcode": "201517",
        "address": "上海市金山区吕巷镇璜溪东街57号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.18336448560434,
            "lat": 30.832375275167646
        }
    },
    {
        "id": 177,
        "netallname": "上海农村商业银行股份有限公司干巷支行",
        "netname": "干巷支行",
        "publicconntel": "021-57201209",
        "postcode": "201518",
        "address": "上海市金山区吕巷镇新溪街146号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.24320053297987,
            "lat": 30.834205992933352
        }
    },
    {
        "id": 178,
        "netallname": "上海农村商业银行股份有限公司朱泾支行",
        "netname": "朱泾支行",
        "publicconntel": "021-57317423",
        "postcode": "201599",
        "address": "上海市金山区朱泾镇金龙新街518号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.17486767788729,
            "lat": 30.892231442734886
        }
    },
    {
        "id": 179,
        "netallname": "上海农村商业银行股份有限公司石化分理处",
        "netname": "石化分理处",
        "publicconntel": "021-37960075",
        "postcode": "200540",
        "address": "上海市金山区卫零路505号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.34307197825616,
            "lat": 30.732473815231327
        }
    },
    {
        "id": 180,
        "netallname": "上海农村商业银行股份有限公司卫清东路分理处",
        "netname": "卫清东路分理处",
        "publicconntel": "021-67240635",
        "postcode": "201508",
        "address": "上海市金山区卫清东路2784号",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.36578228688792,
            "lat": 30.741140811752256
        }
    },
    {
        "id": 181,
        "netallname": "上海农村商业银行股份有限公司金山新城区支行",
        "netname": "金山新城区支行",
        "publicconntel": "021-37905311",
        "postcode": "201508",
        "address": "上海市金山区海汇街86-104号1-2层",
        "net_code": "31162",
        "province": "上海市",
        "area": "金山区",
        "location": {
            "lng": 121.34670830189275,
            "lat": 30.752682924585873
        }
    },
    {
        "id": 182,
        "netallname": "上海农村商业银行股份有限公司青浦支行",
        "netname": "青浦支行",
        "publicconntel": "021-59717940",
        "postcode": "201700",
        "address": "上海市青浦区公园路399号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.12495181858057,
            "lat": 31.15418687794699
        }
    },
    {
        "id": 183,
        "netallname": "上海农村商业银行股份有限公司赵巷支行",
        "netname": "赵巷支行",
        "publicconntel": "021-39780032",
        "postcode": "201703",
        "address": "上海市青浦区赵巷镇赵兴路94号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.20168340529294,
            "lat": 31.155187546914416
        }
    },
    {
        "id": 184,
        "netallname": "上海农村商业银行股份有限公司徐泾支行",
        "netname": "徐泾支行",
        "publicconntel": "021-59760508",
        "postcode": "201702",
        "address": "上海市青浦区徐泾镇盈港东路1775号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.27955473688382,
            "lat": 31.177957199098884
        }
    },
    {
        "id": 185,
        "netallname": "上海农村商业银行股份有限公司华新支行",
        "netname": "华新支行",
        "publicconntel": "021-59791490",
        "postcode": "201708",
        "address": "上海市青浦区华新镇新府中路1678、1680、1682、1684号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.23773635435937,
            "lat": 31.244649270173298
        }
    },
    {
        "id": 186,
        "netallname": "上海农村商业银行股份有限公司凤溪支行",
        "netname": "凤溪支行",
        "publicconntel": "021-59771136",
        "postcode": "201705",
        "address": "上海市青浦区华新镇凤星路1531号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.23455648131174,
            "lat": 31.204770270330947
        }
    },
    {
        "id": 187,
        "netallname": "上海农村商业银行股份有限公司重固支行",
        "netname": "重固支行",
        "publicconntel": "021-59788328",
        "postcode": "201706",
        "address": "上海市青浦区重固镇北青公路6388号1404-1406室",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.20224175696404,
            "lat": 31.1994230893974
        }
    },
    {
        "id": 188,
        "netallname": "上海农村商业银行股份有限公司白鹤支行",
        "netname": "白鹤支行",
        "publicconntel": "021-59746716",
        "postcode": "201709",
        "address": "上海市青浦区白鹤镇外青松公路2727号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.14814402679639,
            "lat": 31.26508778645046
        }
    },
    {
        "id": 189,
        "netallname": "上海农村商业银行股份有限公司赵屯支行",
        "netname": "赵屯支行",
        "publicconntel": "021-59211861",
        "postcode": "201711",
        "address": "上海市青浦区白鹤镇赵江路201号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.0876893577382,
            "lat": 31.263473052761142
        }
    },
    {
        "id": 190,
        "netallname": "上海农村商业银行股份有限公司大盈支行",
        "netname": "大盈支行",
        "publicconntel": "021-59221398",
        "postcode": "201712",
        "address": "上海市青浦区香花桥街道大盈路415号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.09746016209223,
            "lat": 31.21995906470694
        }
    },
    {
        "id": 191,
        "netallname": "上海农村商业银行股份有限公司香花桥支行",
        "netname": "香花桥支行",
        "publicconntel": "021-59702043",
        "postcode": "201707",
        "address": "上海市青浦区北青公路9188号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.14185417964946,
            "lat": 31.192360358476915
        }
    },
    {
        "id": 192,
        "netallname": "上海农村商业银行股份有限公司环城支行",
        "netname": "环城支行",
        "publicconntel": "021-59715355",
        "postcode": "201700",
        "address": "上海市青浦区青湖路885号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.14028349246526,
            "lat": 31.15119091668336
        }
    },
    {
        "id": 193,
        "netallname": "上海农村商业银行股份有限公司盈中支行",
        "netname": "盈中支行",
        "publicconntel": "021-39780031",
        "postcode": "201700",
        "address": "上海市青浦区淀山湖大道347、349、351、353、355、357号及2号二层211、213室。",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.10128965143278,
            "lat": 31.1478456697459
        }
    },
    {
        "id": 194,
        "netallname": "上海农村商业银行股份有限公司朱家角支行",
        "netname": "朱家角支行",
        "publicconntel": "021-59245078",
        "postcode": "201713",
        "address": "上海市青浦区朱家角镇祥凝浜路98号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.07185506305625,
            "lat": 31.115029751532585
        }
    },
    {
        "id": 195,
        "netallname": "上海农村商业银行股份有限公司沈巷支行",
        "netname": "沈巷支行",
        "publicconntel": "021-59830625",
        "postcode": "201714",
        "address": "上海市青浦区朱家角镇沈巷路89号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.06262891750242,
            "lat": 31.08087008665578
        }
    },
    {
        "id": 196,
        "netallname": "上海农村商业银行股份有限公司小蒸分理处",
        "netname": "小蒸分理处",
        "publicconntel": "021-59812475",
        "postcode": "201716",
        "address": "上海市青浦区练塘镇共喜路202号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.08560660766754,
            "lat": 30.994243111299994
        }
    },
    {
        "id": 197,
        "netallname": "上海农村商业银行股份有限公司蒸淀支行",
        "netname": "蒸淀支行",
        "publicconntel": "021-59821112",
        "postcode": "201717",
        "address": "上海市青浦区朱枫公路6338号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.03455637624758,
            "lat": 30.97729204541224
        }
    },
    {
        "id": 198,
        "netallname": "上海农村商业银行股份有限公司练塘支行",
        "netname": "练塘支行",
        "publicconntel": "021-59253992",
        "postcode": "201715",
        "address": "上海市青浦区练塘镇练新路129号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.04810684505182,
            "lat": 31.013925174937977
        }
    },
    {
        "id": 199,
        "netallname": "上海农村商业银行股份有限公司莲盛支行",
        "netname": "莲盛支行",
        "publicconntel": "021-59272891",
        "postcode": "201722",
        "address": "上海市青浦区金泽镇镇中路53号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 120.99495630977322,
            "lat": 31.056095019556388
        }
    },
    {
        "id": 200,
        "netallname": "上海农村商业银行股份有限公司金泽支行",
        "netname": "金泽支行",
        "publicconntel": "021-59261081",
        "postcode": "201718",
        "address": "上海市青浦区金泽镇金溪街235号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 120.92887902615514,
            "lat": 31.041800876591765
        }
    },
    {
        "id": 201,
        "netallname": "上海农村商业银行股份有限公司商榻支行",
        "netname": "商榻支行",
        "publicconntel": "021-59282973",
        "postcode": "201719",
        "address": "上海市青浦区金泽镇商蔡路48号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 120.93160784742994,
            "lat": 31.12123855812721
        }
    },
    {
        "id": 202,
        "netallname": "上海农村商业银行股份有限公司福泉分理处",
        "netname": "福泉分理处",
        "publicconntel": "021-59781223",
        "postcode": "201706",
        "address": "上海市青浦区重固镇福泉山路489号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.18767323133889,
            "lat": 31.206287999003415
        }
    },
    {
        "id": 203,
        "netallname": "上海农村商业银行股份有限公司西虹桥支行",
        "netname": "西虹桥支行",
        "publicconntel": "021-69766961",
        "postcode": "201702",
        "address": "上海市青浦区诸光路1111号",
        "net_code": "31185",
        "province": "上海市",
        "area": "青浦区",
        "location": {
            "lng": 121.31103322324248,
            "lat": 31.185104378459357
        }
    },
    {
        "id": 204,
        "netallname": "上海农村商业银行股份有限公司崇明支行",
        "netname": "崇明支行",
        "publicconntel": "021-59622995",
        "postcode": "202150",
        "address": "上海市崇明县城桥镇北门路188号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.40440650701899,
            "lat": 31.632662859390823
        }
    },
    {
        "id": 205,
        "netallname": "上海农村商业银行股份有限公司三星支行",
        "netname": "三星支行",
        "publicconntel": "021-59600764",
        "postcode": "202152",
        "address": "上海市崇明县三星镇星月路161号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.29321249929816,
            "lat": 31.746718027403315
        }
    },
    {
        "id": 206,
        "netallname": "上海农村商业银行股份有限公司海桥分理处",
        "netname": "海桥分理处",
        "publicconntel": "021-59300507",
        "postcode": "202152",
        "address": "上海市崇明县三星镇海桥公路33号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.31707249345723,
            "lat": 31.792522402996962
        }
    },
    {
        "id": 207,
        "netallname": "上海农村商业银行股份有限公司庙镇支行",
        "netname": "庙镇支行",
        "publicconntel": "021-59361648",
        "postcode": "202153",
        "address": "上海市崇明县庙镇镇合作公路7号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.35378828239675,
            "lat": 31.720679146854245
        }
    },
    {
        "id": 208,
        "netallname": "上海农村商业银行股份有限公司猛将庙分理处",
        "netname": "猛将庙分理处",
        "publicconntel": "021-59382530",
        "postcode": "202153",
        "address": "上海市崇明县庙镇镇合作公路1303号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.373327980409,
            "lat": 31.747408409788626
        }
    },
    {
        "id": 209,
        "netallname": "上海农村商业银行股份有限公司江口分理处",
        "netname": "江口分理处",
        "publicconntel": "021-69361223",
        "postcode": "202165",
        "address": "上海市崇明县宏海公路253号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.36784864378134,
            "lat": 31.686413714337647
        }
    },
    {
        "id": 210,
        "netallname": "上海农村商业银行股份有限公司城桥支行",
        "netname": "城桥支行",
        "publicconntel": "021-59611675",
        "postcode": "202150",
        "address": "上海市崇明县城桥镇中津桥路114号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.40598659317372,
            "lat": 31.638569088808744
        }
    },
    {
        "id": 211,
        "netallname": "上海农村商业银行股份有限公司港西支行",
        "netname": "港西支行",
        "publicconntel": "021-59671238",
        "postcode": "202154",
        "address": "上海市崇明县三双公路1581弄15号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.42162764976419,
            "lat": 31.69463422304536
        }
    },
    {
        "id": 212,
        "netallname": "上海农村商业银行股份有限公司金珠分理处",
        "netname": "金珠分理处",
        "publicconntel": "021-59673003",
        "postcode": "202150",
        "address": "上海市崇明县城桥镇高岛路222号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.41864170291007,
            "lat": 31.64890205262775
        }
    },
    {
        "id": 213,
        "netallname": "上海农村商业银行股份有限公司鳌山支行",
        "netname": "鳌山支行",
        "publicconntel": "021-59691470",
        "postcode": "202155",
        "address": "上海市崇明县城桥镇长侯路69号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.4684070547218,
            "lat": 31.623373172805927
        }
    },
    {
        "id": 214,
        "netallname": "上海农村商业银行股份有限公司东平支行",
        "netname": "东平支行",
        "publicconntel": "021-59331210",
        "postcode": "202155",
        "address": "上海市崇明县建设镇镇中路238号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.46142480536575,
            "lat": 31.66329174129908
        }
    },
    {
        "id": 215,
        "netallname": "上海农村商业银行股份有限公司大同分理处",
        "netname": "大同分理处",
        "publicconntel": "021-59392995",
        "postcode": "202155",
        "address": "上海市崇明县蟠龙公路119弄16号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.49561098934514,
            "lat": 31.63137891521765
        }
    },
    {
        "id": 216,
        "netallname": "上海农村商业银行股份有限公司新河支行",
        "netname": "新河支行",
        "publicconntel": "021-59681659",
        "postcode": "202156",
        "address": "上海市崇明县新河镇新中路661号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.52898026956491,
            "lat": 31.58673977934121
        }
    },
    {
        "id": 217,
        "netallname": "上海农村商业银行股份有限公司新民支行",
        "netname": "新民支行",
        "publicconntel": "021-59371152",
        "postcode": "202156",
        "address": "上海市崇明县新河镇新晨路30号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.54507105831743,
            "lat": 31.623799419794093
        }
    },
    {
        "id": 218,
        "netallname": "上海农村商业银行股份有限公司竖河支行",
        "netname": "竖河支行",
        "publicconntel": "021-59481078",
        "postcode": "202164",
        "address": "上海市崇明县竖新镇",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.61019039612611,
            "lat": 31.62038859304976
        }
    },
    {
        "id": 219,
        "netallname": "上海农村商业银行股份有限公司竖新支行",
        "netname": "竖新支行",
        "publicconntel": "021-59491987",
        "postcode": "202179",
        "address": "上海市崇明县竖新镇前竖公路3050号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.60927906946388,
            "lat": 31.620680864912686
        }
    },
    {
        "id": 220,
        "netallname": "上海农村商业银行股份有限公司堡镇支行",
        "netname": "堡镇支行",
        "publicconntel": "021-59423237",
        "postcode": "202157",
        "address": "上海市崇明县堡镇镇堡镇中路376号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.62906105775386,
            "lat": 31.54666664169628
        }
    },
    {
        "id": 221,
        "netallname": "上海农村商业银行股份有限公司港沿支行",
        "netname": "港沿支行",
        "publicconntel": "021-59461324",
        "postcode": "202158",
        "address": "上海市崇明县港沿公路1111号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.66128779128027,
            "lat": 31.591665376650703
        }
    },
    {
        "id": 222,
        "netallname": "上海农村商业银行股份有限公司五效分理处",
        "netname": "五效分理处",
        "publicconntel": "021-59451282",
        "postcode": "202157",
        "address": "上海市崇明县堡镇镇合五公路1096号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.6816294272823,
            "lat": 31.541384627975305
        }
    },
    {
        "id": 223,
        "netallname": "上海农村商业银行股份有限公司合兴分理处",
        "netname": "合兴分理处",
        "publicconntel": "021-59456442",
        "postcode": "202180",
        "address": "上海市崇明县合五公路4147号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.71791896576582,
            "lat": 31.59033890773418
        }
    },
    {
        "id": 224,
        "netallname": "上海农村商业银行股份有限公司向化支行",
        "netname": "向化支行",
        "publicconntel": "021-59441569",
        "postcode": "202162",
        "address": "上海市崇明县向化镇向化大街173号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.72815667608663,
            "lat": 31.52705669868629
        }
    },
    {
        "id": 225,
        "netallname": "上海农村商业银行股份有限公司汲浜支行",
        "netname": "汲浜支行",
        "publicconntel": "021-69445593",
        "postcode": "202163",
        "address": "上海市崇明县中兴镇广福路27号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.76552340774109,
            "lat": 31.528976115491822
        }
    },
    {
        "id": 226,
        "netallname": "上海农村商业银行股份有限公司陈家镇支行",
        "netname": "陈家镇支行",
        "publicconntel": "021-59430204",
        "postcode": "202162",
        "address": "上海市崇明县陈家镇弘道中路4号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.81249132480487,
            "lat": 31.505287246981087
        }
    },
    {
        "id": 227,
        "netallname": "上海农村商业银行股份有限公司裕安支行",
        "netname": "裕安支行",
        "publicconntel": "021-59404600",
        "postcode": "202162",
        "address": "上海市崇明县陈家镇裕安路83号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.84006071705882,
            "lat": 31.53280870520801
        }
    },
    {
        "id": 228,
        "netallname": "上海农村商业银行股份有限公司绿华支行",
        "netname": "绿华支行",
        "publicconntel": "021-59353438",
        "postcode": "202151",
        "address": "上海市崇明县绿华镇新建路655号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.22485337685417,
            "lat": 31.76885721900402
        }
    },
    {
        "id": 229,
        "netallname": "上海农村商业银行股份有限公司长兴支行",
        "netname": "长兴支行",
        "publicconntel": "021-56851409",
        "postcode": "201913",
        "address": "上海市崇明县长兴镇凤滨路25号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.6989761504429,
            "lat": 31.395876423631975
        }
    },
    {
        "id": 230,
        "netallname": "上海农村商业银行股份有限公司横沙支行",
        "netname": "横沙支行",
        "publicconntel": "021-56890799",
        "postcode": "201914",
        "address": "上海市崇明县横沙乡新环路60号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.84809994052537,
            "lat": 31.34498304538596
        }
    },
    {
        "id": 231,
        "netallname": "上海农村商业银行股份有限公司新村分理处",
        "netname": "新村分理处",
        "publicconntel": "021-39601587",
        "postcode": "202172",
        "address": "上海市崇明县新村乡新中村新跃288号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.33545175681846,
            "lat": 31.835518936514696
        }
    },
    {
        "id": 232,
        "netallname": "上海农村商业银行股份有限公司元沙分理处",
        "netname": "元沙分理处",
        "publicconntel": "021-66851073",
        "postcode": "201913",
        "address": "上海市崇明区长兴镇仁建路800弄11号105室",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明区",
        "location": {
            "lng": 121.7819453316673,
            "lat": 31.368583712947142
        }
    },
    {
        "id": 233,
        "netallname": "上海农村商业银行股份有限公司裕鸿佳苑分理处",
        "netname": "裕鸿佳苑分理处",
        "publicconntel": "021-59433013",
        "postcode": "202162",
        "address": "上海市崇明县安通路171号103-105室",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.854466315217,
            "lat": 31.526940701644545
        }
    },
    {
        "id": 234,
        "netallname": "上海农村商业银行股份有限公司崇明新城分理处",
        "netname": "崇明新城分理处",
        "publicconntel": "021-59620370",
        "postcode": "202150",
        "address": "上海市崇明县城桥镇乔松路586-588号",
        "net_code": "31210",
        "province": "上海市",
        "area": "崇明县",
        "location": {
            "lng": 121.44129249610688,
            "lat": 31.632370716358757
        }
    },
    {
        "id": 235,
        "netallname": "上海农村商业银行股份有限公司徐汇支行",
        "netname": "徐汇支行",
        "publicconntel": "021-64439695",
        "postcode": "200032",
        "address": "上海市徐汇区肇家浜路3-7号",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.46395218791807,
            "lat": 31.208348145047044
        }
    },
    {
        "id": 236,
        "netallname": "上海农村商业银行股份有限公司龙华支行",
        "netname": "龙华支行",
        "publicconntel": "021-34610107",
        "postcode": "200235",
        "address": "上海市徐汇区龙漕路299号1号楼1层",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.4501275230349,
            "lat": 31.177118866073265
        }
    },
    {
        "id": 237,
        "netallname": "上海农村商业银行股份有限公司长桥支行",
        "netname": "长桥支行",
        "publicconntel": "021-54390327",
        "postcode": "200231",
        "address": "上海市徐汇区上中路462号一层",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.4482369995637,
            "lat": 31.145896856551857
        }
    },
    {
        "id": 238,
        "netallname": "上海农村商业银行股份有限公司康健支行",
        "netname": "康健支行",
        "publicconntel": "021-34610576",
        "postcode": "200233",
        "address": "上海市徐汇区桂平路132号",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.41878063304364,
            "lat": 31.157723818246062
        }
    },
    {
        "id": 239,
        "netallname": "上海农村商业银行股份有限公司徐家汇支行",
        "netname": "徐家汇支行",
        "publicconntel": "021-54240017",
        "postcode": "200030",
        "address": "上海市徐汇区虹桥路416号",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.43730390645608,
            "lat": 31.198921475991803
        }
    },
    {
        "id": 240,
        "netallname": "上海农村商业银行股份有限公司花园分理处",
        "netname": "花园分理处",
        "publicconntel": "021-34190093",
        "postcode": "200232",
        "address": "上海市徐汇区龙华路2522号",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.45911919737604,
            "lat": 31.184196407631756
        }
    },
    {
        "id": 241,
        "netallname": "上海农村商业银行股份有限公司华泾支行",
        "netname": "华泾支行",
        "publicconntel": "021-54825900",
        "postcode": "200231",
        "address": "上海市徐汇区华泾路505号",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.46038271707584,
            "lat": 31.12576474908991
        }
    },
    {
        "id": 242,
        "netallname": "上海农村商业银行股份有限公司漕河泾支行",
        "netname": "漕河泾支行",
        "publicconntel": "021-64081624",
        "postcode": "200235",
        "address": "上海市徐汇区沪闵路9450号",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.43995341274419,
            "lat": 31.170138932315663
        }
    },
    
    {
        "id": 244,
        "netallname": "上海农村商业银行股份有限公司虹梅支行",
        "netname": "虹梅支行",
        "publicconntel": "021-34130596",
        "postcode": "201102",
        "address": "上海市徐汇区古美路1156号",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.40713848224442,
            "lat": 31.162604139064744
        }
    },
    {
        "id": 245,
        "netallname": "上海农村商业银行股份有限公司漕河泾开发区支行",
        "netname": "漕河泾开发区支行",
        "publicconntel": "021-54451197",
        "postcode": "200231",
        "address": "上海市虹梅路2005号",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.40325368281225,
            "lat": 31.17732859533947
        }
    },
    
    {
        "id": 247,
        "netallname": "上海农村商业银行股份有限公司华发路分理处",
        "netname": "华发路分理处",
        "publicconntel": "021-52211960",
        "postcode": "200231",
        "address": "上海市徐汇区华发路39、41号1-2层",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.46042448379053,
            "lat": 31.13316637049602
        }
    },
    {
        "id": 248,
        "netallname": "上海农村商业银行股份有限公司淮海中路支行",
        "netname": "淮海中路支行",
        "publicconntel": "021-54069951",
        "postcode": "200021",
        "address": "上海市徐汇区淮海中路1216号",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.45953676211607,
            "lat": 31.22065727197876
        }
    },
    {
        "id": 249,
        "netallname": "上海农村商业银行股份有限公司龙水南路分理处",
        "netname": "龙水南路分理处",
        "publicconntel": "021-54038170",
        "postcode": "200232",
        "address": "上海市徐汇区龙水南路314号",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.46218392831832,
            "lat": 31.159853801652407
        }
    },
    {
        "id": 250,
        "netallname": "上海农村商业银行股份有限公司南丹路支行",
        "netname": "南丹路支行",
        "publicconntel": "021-54205358",
        "postcode": "200030",
        "address": "上海市徐汇区漕溪北路559号",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.44385267399676,
            "lat": 31.19460053423323
        }
    },
    {
        "id": 251,
        "netallname": "上海农村商业银行股份有限公司汇成分理处",
        "netname": "汇成分理处",
        "publicconntel": "021-54726631",
        "postcode": "200237",
        "address": "上海市徐汇区百色路1155号",
        "net_code": "31241",
        "province": "上海市",
        "area": "徐汇区",
        "location": {
            "lng": 121.44077156963995,
            "lat": 31.149356632531752
        }
    },
    {
        "id": 252,
        "netallname": "上海农村商业银行股份有限公司普陀支行",
        "netname": "普陀支行",
        "publicconntel": "021-56354464",
        "postcode": "200333",
        "address": "上海市普陀区新村路599号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.42863491423378,
            "lat": 31.271292452624465
        }
    },
    {
        "id": 253,
        "netallname": "上海农村商业银行股份有限公司长征支行",
        "netname": "长征支行",
        "publicconntel": "021-62653461",
        "postcode": "200333",
        "address": "上海市普陀区大渡河路1665号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.4042778606869,
            "lat": 31.254704101347226
        }
    },
    {
        "id": 254,
        "netallname": "上海农村商业银行股份有限公司真北支行",
        "netname": "真北支行",
        "publicconntel": "021-52703160",
        "postcode": "200333",
        "address": "上海市普陀区金沙江路1965号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.3799549589189,
            "lat": 31.23995047040611
        }
    },
    {
        "id": 255,
        "netallname": "上海农村商业银行股份有限公司桃浦支行",
        "netname": "桃浦支行",
        "publicconntel": "021-62509476",
        "postcode": "200333",
        "address": "上海市普陀区武威路88弄18号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.38346215652827,
            "lat": 31.28375772082544
        }
    },
    {
        "id": 256,
        "netallname": "上海农村商业银行股份有限公司杨家桥支行",
        "netname": "杨家桥支行",
        "publicconntel": "021-62841949",
        "postcode": "200331",
        "address": "上海市普陀区真南路439号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.39877578794679,
            "lat": 31.27437641940106
        }
    },
    {
        "id": 257,
        "netallname": "上海农村商业银行股份有限公司真如支行",
        "netname": "真如支行",
        "publicconntel": "021-52780295",
        "postcode": "200333",
        "address": "上海市普陀区铜川路1999号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.38883968549754,
            "lat": 31.25902991690664
        }
    },
    {
        "id": 258,
        "netallname": "上海农村商业银行股份有限公司长寿支行",
        "netname": "长寿支行",
        "publicconntel": "021-62773961",
        "postcode": "200060",
        "address": "上海市普陀区普陀路249号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.44688048278597,
            "lat": 31.250767131637463
        }
    },
    {
        "id": 259,
        "netallname": "上海农村商业银行股份有限公司古浪支行",
        "netname": "古浪支行",
        "publicconntel": "021-62507672",
        "postcode": "200331",
        "address": "上海市普陀区祁安路40-44号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.39221196653745,
            "lat": 31.290205129611362
        }
    },
    {
        "id": 260,
        "netallname": "上海农村商业银行股份有限公司长风支行",
        "netname": "长风支行",
        "publicconntel": "021-52660939",
        "postcode": "200062",
        "address": "上海市普陀区金沙江路718号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.40600445687711,
            "lat": 31.238075482873914
        }
    },
    {
        "id": 261,
        "netallname": "上海农村商业银行股份有限公司铜川分理处",
        "netname": "铜川分理处",
        "publicconntel": "021-62143131",
        "postcode": "200333",
        "address": "上海市普陀区铜川路296号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.42204189526537,
            "lat": 31.259238209616264
        }
    },
    {
        "id": 262,
        "netallname": "上海农村商业银行股份有限公司金沙江分理处",
        "netname": "金沙江分理处",
        "publicconntel": "021-62653467",
        "postcode": "200333",
        "address": "上海市普陀区真北路1388号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.39257617738495,
            "lat": 31.24709648048383
        }
    },
    {
        "id": 263,
        "netallname": "上海农村商业银行股份有限公司白丽分理处",
        "netname": "白丽分理处",
        "publicconntel": "021-66951824",
        "postcode": "200331",
        "address": "上海市普陀区银杏路26号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.35475719471981,
            "lat": 31.29348817345754
        }
    },
    {
        "id": 264,
        "netallname": "上海农村商业银行股份有限公司高陵分理处",
        "netname": "高陵分理处",
        "publicconntel": "021-52769208",
        "postcode": "200333",
        "address": "上海市普陀区高陵路525号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.3907714825137,
            "lat": 31.265703390142328
        }
    },
    {
        "id": 265,
        "netallname": "上海农村商业银行股份有限公司金鼎分理处",
        "netname": "金鼎分理处",
        "publicconntel": "021-32552382",
        "postcode": "200331",
        "address": "上海市普陀区金鼎路1680号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.37495402926346,
            "lat": 31.264623429173344
        }
    },
    {
        "id": 266,
        "netallname": "上海农村商业银行股份有限公司怒江支行",
        "netname": "怒江支行",
        "publicconntel": "021-60837581",
        "postcode": "200333",
        "address": "上海市普陀区怒江北路407号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.39670937266351,
            "lat": 31.241461299074167
        }
    },
    {
        "id": 267,
        "netallname": "上海农村商业银行股份有限公司同普分理处",
        "netname": "同普分理处",
        "publicconntel": "021-52707305",
        "postcode": "200333",
        "address": "上海市普陀区同普路1538号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.36947240375336,
            "lat": 31.240267146024337
        }
    },
    {
        "id": 268,
        "netallname": "上海农村商业银行股份有限公司甘泉分理处",
        "netname": "甘泉分理处",
        "publicconntel": "021-56722367",
        "postcode": "200065",
        "address": "上海市普陀区延长西路60号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.44870537425999,
            "lat": 31.270851391451714
        }
    },
    {
        "id": 269,
        "netallname": "上海农村商业银行股份有限公司桃浦新村分理处",
        "netname": "桃浦新村分理处",
        "publicconntel": "021-56519982",
        "postcode": "200331",
        "address": "上海市普陀区白丽路79、81号",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.35820489575863,
            "lat": 31.285050797888882
        }
    },
    {
        "id": 270,
        "netallname": "上海农村商业银行股份有限公司长风生态商务区支行",
        "netname": "长风生态商务区支行",
        "publicconntel": "021-62260317",
        "postcode": "200062",
        "address": "上海市普陀区云岭东路651号一层101A室 ",
        "net_code": "31261",
        "province": "上海市",
        "area": "普陀区",
        "location": {
            "lng": 121.388825,
            "lat": 31.22929
        }
     
    },
    {
        "id": 271,
        "netallname": "上海农村商业银行股份有限公司黄浦支行",
        "netname": "黄浦支行",
        "publicconntel": "021-63620175",
        "postcode": "200025",
        "address": "上海市黄浦区建国中路29号东辅楼",
        "net_code": "31280",
        "province": "上海市",
        "area": "黄浦区",
        "location": {
            "lng": 121.4773189002455,
            "lat": 31.216155761816154
        }
    },
    {
        "id": 272,
        "netallname": "上海农村商业银行股份有限公司瞿溪路支行",
        "netname": "瞿溪路支行",
        "publicconntel": "021-63011313*103",
        "postcode": "200023",
        "address": "上海市黄浦区瞿溪路822号",
        "net_code": "31280",
        "province": "上海市",
        "area": "黄浦区",
        "location": {
            "lng": 121.48740435766373,
            "lat": 31.206451284822364
        }
    },
    {
        "id": 273,
        "netallname": "上海农村商业银行股份有限公司西藏南路支行",
        "netname": "西藏南路支行",
        "publicconntel": "021-33660586",
        "postcode": "200011",
        "address": "上海市黄浦区西藏南路878-880号",
        "net_code": "31280",
        "province": "上海市",
        "area": "黄浦区",
        "location": {
            "lng": 121.49190939258442,
            "lat": 31.219672060275588
        }
    },
    {
        "id": 274,
        "netallname": "上海农村商业银行股份有限公司外滩支行",
        "netname": "外滩支行",
        "publicconntel": "021-63230932",
        "postcode": "200001",
        "address": "上海市黄浦区福州路355、365号一楼（一楼商场东）、二楼（办公区201、202、203、204室）",
        "net_code": "31280",
        "province": "上海市",
        "area": "黄浦区",
        "location": {
            "lng": 121.4902463196192,
            "lat": 31.239790712241923
        }
    },
    {
        "id": 275,
        "netallname": "上海农村商业银行股份有限公司黄陂南路支行",
        "netname": "黄陂南路支行",
        "publicconntel": "021-53860932",
        "postcode": "200025",
        "address": "上海市黄浦区黄陂南路688号底层",
        "net_code": "31280",
        "province": "上海市",
        "area": "黄浦区",
        "location": {
            "lng": 121.48340459848222,
            "lat": 31.220613764236578
        }
    },
    {
        "id": 276,
        "netallname": "上海农村商业银行股份有限公司长宁支行",
        "netname": "长宁支行",
        "publicconntel": "021-52067885",
        "postcode": "200051",
        "address": "上海市长宁区古北路555弄8号",
        "net_code": "31286",
        "province": "上海市",
        "area": "长宁区",
        "location": {
            "lng": 121.40725960975941,
            "lat": 31.21348669044463
        }
    },
    {
        "id": 277,
        "netallname": "上海农村商业银行股份有限公司新泾支行",
        "netname": "新泾支行",
        "publicconntel": "021-62386856",
        "postcode": "200335",
        "address": "上海市长宁区泉口路216-234号",
        "net_code": "31286",
        "province": "上海市",
        "area": "长宁区",
        "location": {
            "lng": 121.37027454835341,
            "lat": 31.219803861757804
        }
    },
    {
        "id": 278,
        "netallname": "上海农村商业银行股份有限公司程桥支行",
        "netname": "程桥支行",
        "publicconntel": "021-62421461",
        "postcode": "200335",
        "address": "上海市长宁区虹桥路2308号",
        "net_code": "31286",
        "province": "上海市",
        "area": "长宁区",
        "location": {
            "lng": 121.37829115787707,
            "lat": 31.19586233487788
        }
    },
    {
        "id": 279,
        "netallname": "上海农村商业银行股份有限公司天山支行",
        "netname": "天山支行",
        "publicconntel": "021-62620752",
        "postcode": "200336",
        "address": "上海市长宁区威宁路310号",
        "net_code": "31286",
        "province": "上海市",
        "area": "长宁区",
        "location": {
            "lng": 121.39177832399031,
            "lat": 31.21854311331923
        }
    },
    // {
    //     "id": 280,
    //     "netallname": "上海农村商业银行股份有限公司延安西路支行",
    //     "netname": "延安西路支行",
    //     "publicconntel": "021-52386905",
    //     "postcode": "200050",
    //     "address": "上海市长宁区延安西路728号1A室",
    //     "net_code": "31286",
    //     "province": "上海市",
    //     "area": "长宁区",
    //     "location": {
    //         "lng": 121.44031224177844,
    //         "lat": 31.2215939148959
    //     }
    // },
    {
        "id": 281,
        "netallname": "上海农村商业银行股份有限公司绥宁支行",
        "netname": "绥宁支行",
        "publicconntel": "021-32527791",
        "postcode": "200335",
        "address": "上海市长宁区仙霞西路901号、905号、909号底层",
        "net_code": "31286",
        "province": "上海市",
        "area": "长宁区",
        "location": {
            "lng": 121.35547400029643,
            "lat": 31.215601864548184
        }
    },
    {
        "id": 282,
        "netallname": "上海农村商业银行股份有限公司定西路支行",
        "netname": "定西路支行",
        "publicconntel": "021-52049157",
        "postcode": "200050",
        "address": "上海市长宁区定西路1308号-5号",
        "net_code": "31286",
        "province": "上海市",
        "area": "长宁区",
        "location": {
            "lng": 121.4292808524887,
            "lat": 31.22182513241902
        }
    },
    {
        "id": 283,
        "netallname": "上海农村商业银行股份有限公司法华镇路支行",
        "netname": "法华镇路支行",
        "publicconntel": "021-52306500",
        "postcode": "200052",
        "address": "上海市长宁区法华镇路457弄3号101室",
        "net_code": "31286",
        "province": "上海市",
        "area": "长宁区",
        "location": {
            "lng": 121.43318271433573,
            "lat": 31.21128230750991
        }
    },
    {
        "id": 284,
        "netallname": "上海农村商业银行股份有限公司淞虹路支行",
        "netname": "淞虹路支行",
        "publicconntel": "021-62782856",
        "postcode": "200335",
        "address": "上海市长宁区淞虹路152号一层",
        "net_code": "31286",
        "province": "上海市",
        "area": "长宁区",
        "location": {
            "lng": 121.36825134336179,
            "lat": 31.226382502962238
        }
    },
    {
        "id": 285,
        "netallname": "上海农村商业银行股份有限公司浦东分行",
        "netname": "浦东分行",
        "publicconntel": "021-68407901",
        "postcode": "200122",
        "address": "中国（上海）自由贸易试验区世纪大道1500号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.53923431377483,
            "lat": 31.23102946456873
        }
    },
    {
        "id": 286,
        "netallname": "上海农村商业银行股份有限公司金杨支行",
        "netname": "金杨支行",
        "publicconntel": "021-60893851",
        "postcode": "200136",
        "address": "上海市浦东新区长岛路1178号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.59916196675304,
            "lat": 31.26694016119967
        }
    },
    {
        "id": 287,
        "netallname": "上海农村商业银行股份有限公司外高桥支行",
        "netname": "外高桥支行",
        "publicconntel": "021-58677615",
        "postcode": "200137",
        "address": "上海市浦东新区高桥镇西街215号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.58642686830086,
            "lat": 31.34830831771538
        }
    },
    {
        "id": 288,
        "netallname": "上海农村商业银行股份有限公司妙境支行",
        "netname": "妙境支行",
        "publicconntel": "021-58373118",
        "postcode": "201200",
        "address": "上海市浦东新区妙境路578号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.69756442650343,
            "lat": 31.19579918624977
        }
    },
    {
        "id": 289,
        "netallname": "上海农村商业银行股份有限公司施湾支行",
        "netname": "施湾支行",
        "publicconntel": "021-68960724",
        "postcode": "201202",
        "address": "上海市浦东新区机场镇施新路859号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.76424211327016,
            "lat": 31.1541702701064
        }
    },
    {
        "id": 290,
        "netallname": "上海农村商业银行股份有限公司六团支行",
        "netname": "六团支行",
        "publicconntel": "021-58594187",
        "postcode": "201202",
        "address": "上海市浦东新区川六公路1733号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.73273934481527,
            "lat": 31.16000877806097
        }
    },
    {
        "id": 291,
        "netallname": "上海农村商业银行股份有限公司江镇支行",
        "netname": "江镇支行",
        "publicconntel": "021-58931431",
        "postcode": "201202",
        "address": "上海市浦东新区机场镇晨阳路25号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.75411340962805,
            "lat": 31.181468296723924
        }
    },
    {
        "id": 292,
        "netallname": "上海农村商业银行股份有限公司蔡路支行",
        "netname": "蔡路支行",
        "publicconntel": "021-68907690",
        "postcode": "201201",
        "address": "上海市浦东新区蔡路镇塘东街25号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.73540140043133,
            "lat": 31.219592928897896
        }
    },
    {
        "id": 293,
        "netallname": "上海农村商业银行股份有限公司黄楼支行",
        "netname": "黄楼支行",
        "publicconntel": "021-58941140",
        "postcode": "201205",
        "address": "上海市浦东新区川沙镇黄楼社区迎春街55号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.67709135493071,
            "lat": 31.170831778360093
        }
    },
    {
        "id": 294,
        "netallname": "上海农村商业银行股份有限公司合庆支行",
        "netname": "合庆支行",
        "publicconntel": "021-58971517",
        "postcode": "201201",
        "address": "上海市浦东新区庆荣路212号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.72612345409027,
            "lat": 31.24165591533366
        }
    },
    {
        "id": 295,
        "netallname": "上海农村商业银行股份有限公司川沙支行",
        "netname": "川沙支行",
        "publicconntel": "021-58983021",
        "postcode": "201200",
        "address": "上海市浦东新区川沙路5228号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.7052988611986,
            "lat": 31.194869755835057
        }
    },
    {
        "id": 296,
        "netallname": "上海农村商业银行股份有限公司王港支行",
        "netname": "王港支行",
        "publicconntel": "021-58580142",
        "postcode": "201201",
        "address": "上海市浦东新区上丰路1818号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.68647003006522,
            "lat": 31.247787475626435
        }
    },
    {
        "id": 297,
        "netallname": "上海农村商业银行股份有限公司龚路支行",
        "netname": "龚路支行",
        "publicconntel": "021-58562524",
        "postcode": "201209",
        "address": "上海市浦东新区龚华路219号、221号、223号1-2层 ",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location":{
            "lng": 121.691737,
            "lat": 31.270905
        }
    },
    {
        "id": 298,
        "netallname": "上海农村商业银行股份有限公司曹路支行",
        "netname": "曹路支行",
        "publicconntel": "021-58639262",
        "postcode": "201209",
        "address": "上海市浦东新区川沙路450号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.6749054928621,
            "lat": 31.28307657528109
        }
    },
    {
        "id": 299,
        "netallname": "上海农村商业银行股份有限公司唐镇支行",
        "netname": "唐镇支行",
        "publicconntel": "021-58960359",
        "postcode": "201203",
        "address": "上海市浦东新区唐镇路376号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.66144234025174,
            "lat": 31.21558049280446
        }
    },
    {
        "id": 300,
        "netallname": "上海农村商业银行股份有限公司张江支行",
        "netname": "张江支行",
        "publicconntel": "021-58551071",
        "postcode": "201203",
        "address": "中国（上海）自由贸易试验区张江路727号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.62405621328303,
            "lat": 31.20903911328164
        }
    },
    {
        "id": 301,
        "netallname": "上海农村商业银行股份有限公司孙桥支行",
        "netname": "孙桥支行",
        "publicconntel": "021-58575991",
        "postcode": "201210",
        "address": "上海市浦东新区孙桥路160号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.63699642812043,
            "lat": 31.18944815656633
        }
    },
    {
        "id": 302,
        "netallname": "上海农村商业银行股份有限公司高桥支行",
        "netname": "高桥支行",
        "publicconntel": "021-58621994",
        "postcode": "200137",
        "address": "上海市浦东新区夏碧路317号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.59230740344049,
            "lat": 31.342373383826075
        }
    },
    {
        "id": 303,
        "netallname": "上海农村商业银行股份有限公司凌桥支行",
        "netname": "凌桥支行",
        "publicconntel": "021-58642149",
        "postcode": "200137",
        "address": "上海市浦东新区江东路1380弄255号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.55004264392508,
            "lat": 31.371298566398803
        }
    },
    {
        "id": 304,
        "netallname": "上海农村商业银行股份有限公司杨园支行",
        "netname": "杨园支行",
        "publicconntel": "021-68488650",
        "postcode": "201208",
        "address": "上海市浦东新区杨园镇镇南路80号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.64006105306265,
            "lat": 31.310650529495796
        }
    },
    {
        "id": 305,
        "netallname": "上海农村商业银行股份有限公司高东支行",
        "netname": "高东支行",
        "publicconntel": "021-58484917",
        "postcode": "200137",
        "address": "上海市浦东新区光明路635号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.62991913354989,
            "lat": 31.33330845623374
        }
    },
    {
        "id": 306,
        "netallname": "上海农村商业银行股份有限公司金联支行",
        "netname": "金联支行",
        "publicconntel": "021-50714714",
        "postcode": "201206",
        "address": "上海市浦东新区金杨路816号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.59079722791205,
            "lat": 31.260394243408413
        }
    },
    {
        "id": 307,
        "netallname": "上海农村商业银行股份有限公司金桥支行",
        "netname": "金桥支行",
        "publicconntel": "021-58992503",
        "postcode": "201206",
        "address": "上海市浦东新区金桥镇佳林路173号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.61564391904665,
            "lat": 31.273396861928248
        }
    },
    {
        "id": 308,
        "netallname": "上海农村商业银行股份有限公司东沟支行",
        "netname": "东沟支行",
        "publicconntel": "021-68464860",
        "postcode": "201208",
        "address": "上海市浦东新区东靖路858号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.59294568813246,
            "lat": 31.297362436096112
        }
    },
    {
        "id": 309,
        "netallname": "上海农村商业银行股份有限公司高行支行",
        "netname": "高行支行",
        "publicconntel": "021-68977029",
        "postcode": "200137",
        "address": "上海市浦东新区金高路945号115室",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.61699211032891,
            "lat": 31.28967074741112
        }
    },
    {
        "id": 310,
        "netallname": "上海农村商业银行股份有限公司洋泾支行",
        "netname": "洋泾支行",
        "publicconntel": "021-58857596",
        "postcode": "200135",
        "address": "上海市浦东新区沈家弄路956号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.554655846058,
            "lat": 31.246485479586045
        }
    },
    {
        "id": 311,
        "netallname": "上海农村商业银行股份有限公司花木支行",
        "netname": "花木支行",
        "publicconntel": "021-61092556",
        "postcode": "201204",
        "address": "中国（上海）自由贸易试验区浦建路1128号1-2层",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.54658042896412,
            "lat": 31.21271714761838
        }
    },
    {
        "id": 312,
        "netallname": "上海农村商业银行股份有限公司北蔡支行",
        "netname": "北蔡支行",
        "publicconntel": "021-58911083",
        "postcode": "201204",
        "address": "上海市浦东新区北中路201号一层",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.5624782796592,
            "lat": 31.189968041924008
        }
    },
    {
        "id": 313,
        "netallname": "上海农村商业银行股份有限公司严桥支行",
        "netname": "严桥支行",
        "publicconntel": "021-68640717",
        "postcode": "200125",
        "address": "上海市浦东新区严丰路128号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.53519148713225,
            "lat": 31.199000137222452
        }
    },
    {
        "id": 314,
        "netallname": "上海农村商业银行股份有限公司杨思支行",
        "netname": "杨思支行",
        "publicconntel": "021-33903683",
        "postcode": "200126",
        "address": "上海市浦东新区杨思路751号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.50432702223375,
            "lat": 31.16866709908139
        }
    },
    {
        "id": 315,
        "netallname": "上海农村商业银行股份有限公司三林支行",
        "netname": "三林支行",
        "publicconntel": "021-58411232",
        "postcode": "200124",
        "address": "上海市浦东新区三林路925号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.51650548567666,
            "lat": 31.148595905236636
        }
    },
    {
        "id": 316,
        "netallname": "上海农村商业银行股份有限公司六里支行",
        "netname": "六里支行",
        "publicconntel": "021-50864208",
        "postcode": "200125",
        "address": "上海市浦东新区浦三路739号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.52484581486202,
            "lat": 31.190894255198987
        }
    },
    {
        "id": 317,
        "netallname": "上海农村商业银行股份有限公司民耀分理处",
        "netname": "民耀分理处",
        "publicconntel": "021-50213381",
        "postcode": "201209",
        "address": "上海市浦东新区民耀路179号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.65948581917303,
            "lat": 31.27933228633494
        }
    },
    {
        "id": 318,
        "netallname": "上海农村商业银行股份有限公司东波分理处",
        "netname": "东波分理处",
        "publicconntel": "021-68468762",
        "postcode": "201208",
        "address": "上海市浦东新区东波路186号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.5856051720814,
            "lat": 31.290222987461423
        }
    },
    {
        "id": 319,
        "netallname": "上海农村商业银行股份有限公司香山分理处",
        "netname": "香山分理处",
        "publicconntel": "021-50704463",
        "postcode": "200136",
        "address": "上海市浦东新区德平路1116号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.57509814078563,
            "lat": 31.247410119805753
        }
    },
    {
        "id": 320,
        "netallname": "上海农村商业银行股份有限公司凌兆分理处",
        "netname": "凌兆分理处",
        "publicconntel": "021-58418181",
        "postcode": "200124",
        "address": "上海市浦东新区灵岩南路1142号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.50668660311342,
            "lat": 31.14683811883158
        }
    },
    {
        "id": 321,
        "netallname": "上海农村商业银行股份有限公司南新分理处",
        "netname": "南新分理处",
        "publicconntel": "021-58534876",
        "postcode": "200125",
        "address": "上海市浦东新区下南路353号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.54784001767902,
            "lat": 31.17613302997925
        }
    },
    {
        "id": 322,
        "netallname": "上海农村商业银行股份有限公司御桥分理处",
        "netname": "御桥分理处",
        "publicconntel": "021-33925921",
        "postcode": "201204",
        "address": "上海市浦东新区御桥路1970-1976号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.57921396732716,
            "lat": 31.164471604364103
        }
    },
    {
        "id": 323,
        "netallname": "上海农村商业银行股份有限公司益江分理处",
        "netname": "益江分理处",
        "publicconntel": "021-58956570",
        "postcode": "201203",
        "address": "上海市浦东新区益江路121号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.64051435059926,
            "lat": 31.20557223529381
        }
    },
    {
        "id": 324,
        "netallname": "上海农村商业银行股份有限公司潼港分理处",
        "netname": "潼港分理处",
        "publicconntel": "021-38711120",
        "postcode": "200137",
        "address": "上海市浦东新区清溪路206号1层",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.58062884162405,
            "lat": 31.34939128600209
        }
    },
    {
        "id": 325,
        "netallname": "上海农村商业银行股份有限公司芳华分理处",
        "netname": "芳华分理处",
        "publicconntel": "021-50873905",
        "postcode": "201204",
        "address": "上海市浦东新区芳华路496号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.56754146278479,
            "lat": 31.20227484176717
        }
    },
    {
        "id": 326,
        "netallname": "上海农村商业银行股份有限公司和炯路支行",
        "netname": "和炯路支行",
        "publicconntel": "021-58903290",
        "postcode": "200124",
        "address": "上海市浦东新区和炯路558号",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.5154155221946,
            "lat": 31.129298391920944
        }
    },
    {
        "id": 327,
        "netallname": "上海农村商业银行股份有限公司金海华城分理处",
        "netname": "金海华城分理处",
        "publicconntel": "021-38711185",
        "postcode": "201209",
        "address": "上海市浦东新区上川路2225号、2227号、2229号一层",
        "net_code": "31297",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.68217767750794,
            "lat": 31.289034815093327
        }
    },
    {
        "id": 328,
        "netallname": "上海农村商业银行股份有限公司虹口支行",
        "netname": "虹口支行",
        "publicconntel": "021-55884112",
        "postcode": "200437",
        "address": "上海市虹口区松花江路2721号",
        "net_code": "31365",
        "province": "上海市",
        "area": "虹口区",
        "location": {
            "lng": 121.50483533918624,
            "lat": 31.299062158966844
        }
    },
    {
        "id": 329,
        "netallname": "上海农村商业银行股份有限公司大柏树支行",
        "netname": "大柏树支行",
        "publicconntel": "021-65569531",
        "postcode": "200437",
        "address": "上海市虹口区曲阳路800号（曲阳商务中心）一层106室",
        "net_code": "31365",
        "province": "上海市",
        "area": "虹口区",
        "location": {
            "lng": 121.5005960459422,
            "lat": 31.287685005616396
        }
    },
    {
        "id": 330,
        "netallname": "上海农村商业银行股份有限公司江湾支行",
        "netname": "江湾支行",
        "publicconntel": "021-65444234",
        "postcode": "200434",
        "address": "上海市虹口区新市南路1122号",
        "net_code": "31365",
        "province": "上海市",
        "area": "虹口区",
        "location": {
            "lng": 121.48722234030637,
            "lat": 31.30422586235285
        }
    },
    {
        "id": 331,
        "netallname": "上海农村商业银行股份有限公司广中支行",
        "netname": "广中支行",
        "publicconntel": "021-56318632",
        "postcode": "200083",
        "address": "上海市虹口区广中路208号104室",
        "net_code": "31365",
        "province": "上海市",
        "area": "虹口区",
        "location": {
            "lng": 121.48224568376413,
            "lat": 31.282902238015392
        }
    },
    {
        "id": 332,
        "netallname": "上海农村商业银行股份有限公司北外滩支行",
        "netname": "北外滩支行",
        "publicconntel": "021-35051160",
        "postcode": "200080",
        "address": "上海虹口区东长治路701号1幢108室",
        "net_code": "31365",
        "province": "上海市",
        "area": "虹口区",
        "location": {
            "lng": 121.50808826333625,
            "lat": 31.25723771161938
        }
    },
    {
        "id": 333,
        "netallname": "上海农村商业银行股份有限公司曲阳支行",
        "netname": "曲阳支行",
        "publicconntel": "021-65753076",
        "postcode": "200086",
        "address": "上海市虹口区新港路319号",
        "net_code": "31365",
        "province": "上海市",
        "area": "虹口区",
        "location": {
            "lng": 121.50336309640458,
            "lat": 31.275851128175628
        }
    },
    {
        "id": 334,
        "netallname": "上海农村商业银行股份有限公司凉城支行",
        "netname": "凉城支行",
        "publicconntel": "021-55512971",
        "postcode": "200434",
        "address": "上海市虹口区车站南路305号",
        "net_code": "31365",
        "province": "上海市",
        "area": "虹口区",
        "location": {
            "lng": 121.4817244806191,
            "lat": 31.300314687807855
        }
    },
    {
        "id": 335,
        "netallname": "上海农村商业银行股份有限公司溧阳路支行",
        "netname": "溧阳路支行",
        "publicconntel": "021-56723192",
        "postcode": "200081",
        "address": "上海市虹口区溧阳路1111号一层",
        "net_code": "31365",
        "province": "上海市",
        "area": "虹口区",
        "location": {
            "lng": 121.49507260610721,
            "lat": 31.26780212161102
        }
    },
    {
        "id": 336,
        "netallname": "上海农村商业银行股份有限公司祥德路支行",
        "netname": "祥德路支行",
        "publicconntel": "021-56618051",
        "postcode": "200083",
        "address": "上海市虹口区祥德路302号一层",
        "net_code": "31365",
        "province": "上海市",
        "area": "虹口区",
        "location": {
            "lng": 121.49584119450495,
            "lat": 31.276825540119994
        }
    },
    {
        "id": 337,
        "netallname": "上海农村商业银行股份有限公司南滨江支行",
        "netname": "南滨江支行",
        "publicconntel": "021-962999",
        "postcode": "200122",
        "address": "上海市浦东新区滨江大道5299号1楼1-02 ",
        "net_code": "31365",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.517438,
            "lat": 31.214826
        },
    },
    {
        "id": 338,
        "netallname": "上海农村商业银行股份有限公司闸北支行",
        "netname": "闸北支行",
        "publicconntel": "021-52397631",
        "postcode": "200070",
        "address": "上海市闸北区共和路169号一楼",
        "net_code": "31375",
        "province": "上海市",
        "area": "闸北区",
        "location": {
            "lng": 121.46559338040683,
            "lat": 31.25091981326667
        }
    },
    {
        "id": 339,
        "netallname": "上海农村商业银行股份有限公司彭浦支行",
        "netname": "彭浦支行",
        "publicconntel": "021-56036238",
        "postcode": "200072",
        "address": "上海市闸北区灵石路729号",
        "net_code": "31375",
        "province": "上海市",
        "area": "闸北区",
        "location": {
            "lng": 121.4463281362872,
            "lat": 31.289179551816947
        }
    },
    {
        "id": 340,
        "netallname": "上海农村商业银行股份有限公司阳城支行",
        "netname": "阳城支行",
        "publicconntel": "021-66108849",
        "postcode": "200436",
        "address": "上海市闸北区阳城路315号",
        "net_code": "31375",
        "province": "上海市",
        "area": "闸北区",
        "location": {
            "lng": 121.43163642063767,
            "lat": 31.290349679965022
        }
    },
    {
        "id": 341,
        "netallname": "上海农村商业银行股份有限公司永和分理处",
        "netname": "永和分理处",
        "publicconntel": "021-36323462",
        "postcode": "200436",
        "address": "上海市静安区交城路208号",
        "net_code": "31375",
        "province": "上海市",
        "area": "静安区",
        "location": {
            "lng": 121.43460840063773,
            "lat": 31.299681946033548
        }
    },
    {
        "id": 342,
        "netallname": "上海农村商业银行股份有限公司保德路支行",
        "netname": "保德路支行",
        "publicconntel": "021-56834712",
        "postcode": "200435",
        "address": "上海市闸北区保德路1156号",
        "net_code": "31375",
        "province": "上海市",
        "area": "闸北区",
        "location": {
            "lng": 121.45522299665033,
            "lat": 31.321613266106493
        }
    },
    {
        "id": 343,
        "netallname": "上海农村商业银行股份有限公司西藏北路支行",
        "netname": "西藏北路支行",
        "publicconntel": "021-56201009",
        "postcode": "200071",
        "address": "上海市静安区通阁路165号",
        "net_code": "31375",
        "province": "上海市",
        "area": "静安区",
        "location": {
            "lng": 121.47725712018234,
            "lat": 31.265337080725754
        }
    },
    {
        "id": 344,
        "netallname": "上海农村商业银行股份有限公司中兴路支行",
        "netname": "中兴路支行",
        "publicconntel": "021-56625065",
        "postcode": "200070",
        "address": "上海市闸北区中兴路1288-1290号",
        "net_code": "31375",
        "province": "上海市",
        "area": "闸北区",
        "location": {
            "lng": 121.46825078100376,
            "lat": 31.25814089921968
        }
    },
    {
        "id": 345,
        "netallname": "上海农村商业银行股份有限公司汾西路支行",
        "netname": "汾西路支行",
        "publicconntel": "021-56473392",
        "postcode": "200435",
        "address": "上海市闸北区汾西路46号",
        "net_code": "31375",
        "province": "上海市",
        "area": "闸北区",
        "location": {
            "lng": 121.47360960545572,
            "lat": 31.319692801140178
        }
    },
    {
        "id": 346,
        "netallname": "上海农村商业银行股份有限公司静安支行",
        "netname": "静安支行",
        "publicconntel": "021-62711561",
        "postcode": "200041",
        "address": "上海市北京西路770号",
        "net_code": "31375",
        "province": "上海市",
        "area": "静安区",
        "location": {
            "lng": 121.46623840418674,
            "lat": 31.23841284045363
        }
    },
    {
        "id": 347,
        "netallname": "上海农村商业银行股份有限公司余姚路支行",
        "netname": "余姚路支行",
        "publicconntel": "021-32561226",
        "postcode": "200042",
        "address": "上海市静安区余姚路522-532号1-2层",
        "net_code": "31375",
        "province": "上海市",
        "area": "静安区",
        "location": {
            "lng": 121.44025596653148,
            "lat": 31.239379894058995
        }
    },
    {
        "id": 348,
        "netallname": "上海农村商业银行股份有限公司万航渡路支行",
        "netname": "万航渡路支行",
        "publicconntel": "021-62250102",
        "postcode": "200042",
        "address": "上海市静安区万航渡路686号",
        "net_code": "31375",
        "province": "上海市",
        "area": "静安区",
        "location": {
            "lng": 121.43847147455115,
            "lat": 31.233342881844358
        }
    },
    {
        "id": 349,
        "netallname": "上海农村商业银行股份有限公司杨浦支行",
        "netname": "杨浦支行",
        "publicconntel": "021-55069206",
        "postcode": "200433",
        "address": "上海市杨浦区黄兴路1599号",
        "net_code": "31384",
        "province": "上海市",
        "area": "杨浦区",
        "location": {
            "lng": 121.52763284902878,
            "lat": 31.29272947221309
        }
    },
    {
        "id": 350,
        "netallname": "上海农村商业银行股份有限公司控江支行",
        "netname": "控江支行",
        "publicconntel": "021-55055095",
        "postcode": "200092",
        "address": "上海市杨浦区控江路1063号",
        "net_code": "31384",
        "province": "上海市",
        "area": "杨浦区",
        "location": {
            "lng": 121.53582898311198,
            "lat": 31.28499313315219
        }
    },
    {
        "id": 351,
        "netallname": "上海农村商业银行股份有限公司丰乐支行",
        "netname": "丰乐支行",
        "publicconntel": "021-65068155",
        "postcode": "200438",
        "address": "上海市杨浦区殷行路408号",
        "net_code": "31384",
        "province": "上海市",
        "area": "杨浦区",
        "location": {
            "lng": 121.54409707236485,
            "lat": 31.33458315412319
        }
    },
    {
        "id": 352,
        "netallname": "上海农村商业银行股份有限公司中原支行",
        "netname": "中原支行",
        "publicconntel": "021-55227085",
        "postcode": "200433",
        "address": "上海市杨浦区佳木斯路432号",
        "net_code": "31384",
        "province": "上海市",
        "area": "杨浦区",
        "location": {
            "lng": 121.5418704478871,
            "lat": 31.300449239089872
        }
    },
    {
        "id": 353,
        "netallname": "上海农村商业银行股份有限公司双创支行",
        "netname": "双创支行",
        "publicconntel": "021-65199601",
        "postcode": "200090",
        "address": "上海市杨浦区长阳路1687号A号楼A101/102室。",
        "net_code": "31384",
        "province": "上海市",
        "area": "杨浦区",
        "location": {
            "lng": 121.5418400923473,
            "lat": 31.277322386191187
        }
    },
    {
        "id": 354,
        "netallname": "上海农村商业银行股份有限公司长白支行",
        "netname": "长白支行",
        "publicconntel": "021-35030176",
        "postcode": "200093",
        "address": "上海市杨浦区延吉东路287号",
        "net_code": "31384",
        "province": "上海市",
        "area": "杨浦区",
        "location": {
            "lng": 121.54985192198734,
            "lat": 31.296358709207386
        }
    },
    {
        "id": 355,
        "netallname": "上海农村商业银行股份有限公司鞍山支行",
        "netname": "鞍山支行",
        "publicconntel": "021-55062079",
        "postcode": "200092",
        "address": "上海市杨浦区鞍山路100号",
        "net_code": "31384",
        "province": "上海市",
        "area": "杨浦区",
        "location": {
            "lng": 121.51867100022717,
            "lat": 31.281811873608817
        }
    },
    {
        "id": 356,
        "netallname": "上海农村商业银行股份有限公司五角场支行",
        "netname": "五角场支行",
        "publicconntel": "021-65232637",
        "postcode": "200433",
        "address": "上海市杨浦区政通路93号",
        "net_code": "31384",
        "province": "上海市",
        "area": "杨浦区",
        "location": {
            "lng": 121.52390130770306,
            "lat": 31.309740094928728
        }
    },
    {
        "id": 357,
        "netallname": "上海农村商业银行股份有限公司平凉路支行",
        "netname": "平凉路支行",
        "publicconntel": "021-65112359",
        "postcode": "200090",
        "address": "上海市杨浦区平凉路1500号3幢一楼",
        "net_code": "31384",
        "province": "上海市",
        "area": "杨浦区",
        "location": {
            "lng": 121.54608949152833,
            "lat": 31.27131487246484
        }
    },
    {
        "id": 358,
        "netallname": "上海农村商业银行股份有限公司张江科技支行",
        "netname": "张江科技支行",
        "publicconntel": "021-61681383",
        "postcode": "201203",
        "address": "上海市浦东新区张衡路500弄B区8号103-108室",
        "net_code": "31438",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.59714511367967,
            "lat": 31.19235559007986
        }
    },
    {
        "id": 359,
        "netallname": "上海农村商业银行股份有限公司上海自贸试验区分行",
        "netname": "上海自贸试验区分行",
        "publicconntel": "021-33903691",
        "postcode": "200120",
        "address": "上海市浦东新区银城中路8号103室",
        "net_code": "31457",
        "province": "上海市",
        "area": "浦东新区",
        "location": {
            "lng": 121.5140324506077,
            "lat": 31.247176840455896
        }
    },
    {
        "id": 360,
        "netallname": "上海农村商业银行股份有限公司嘉善支行",
        "netname": "嘉善支行",
        "publicconntel": "0573-84013308",
        "postcode": "314100",
        "address": "浙江省嘉善县罗星街道嘉善大道67-73号",
        "net_code": "33001",
        "province": "浙江省",
        "area": "嘉善县",
        "location": {
            "lng": 120.93468288822456,
            "lat": 30.838893786008608
        }
    },
    {
        "id": 361,
        "netallname": "上海农村商业银行股份有限公司嘉善支行姚庄分理处",
        "netname": "嘉善支行姚庄分理处",
        "publicconntel": "0573-84013365",
        "postcode": "314100",
        "address": "浙江省嘉善县姚庄镇兴学路303、305号",
        "net_code": "33001",
        "province": "浙江省",
        "area": "嘉善县",
        "location": {
            "lng": 120.96304356815817,
            "lat": 30.923423286920254
        }
    },
    {
        "id": 362,
        "netallname": "上海农村商业银行股份有限公司湘潭县支行",
        "netname": "湘潭县支行",
        "publicconntel": "0731-57238887",
        "postcode": "411228",
        "address": "湘潭县易俗河镇金桂南路598号",
        "net_code": "43001",
        "province": "湖南省",
        "area": "湘潭县",
        "location": {
            "lng": 112.95835982716065,
            "lat": 27.784127877325478
        }
    },
    {
        "id": 363,
        "netallname": "上海农村商业银行股份有限公司湘潭花石分理处",
        "netname": "湘潭花石分理处",
        "publicconntel": "0731-57551548",
        "postcode": "411228",
        "address": "湖南湘潭县花石镇马垅村288号",
        "net_code": "43001",
        "province": "湖南省",
        "area": "湘潭县",
        "location": {
            "lng": 112.73690075940141,
            "lat": 27.513214677651398
        }
    },
    {
        "id": 364,
        "netallname": "上海农村商业银行股份有限公司湘潭九华分理处",
        "netname": "湘潭九华分理处",
        "publicconntel": "0731-55883006",
        "postcode": "411100",
        "address": "湖南省湘潭市九华经济开发区步步高大道19号",
        "net_code": "43001",
        "province": "湖南省",
        "area": "湘潭九华经济技术开发区",
        "location": {
            "lng": 112.94563365427625,
            "lat": 27.897421112214968
        }
    },
    {
        "id": 365,
        "netallname": "上海农村商业银行股份有限公司昆山支行",
        "netname": "昆山支行",
        "publicconntel": "0512-36628923",
        "postcode": "215300",
        "address": "江苏省昆山市开发区车站路388号玖珑湾花苑18号楼1-5室",
        "net_code": "32001",
        "province": "江苏省",
        "area": "昆山市",
        "location": {
            "lng": 121.65300991049735,
            "lat": 31.03431993515258
        }
    },
    {
        "id": 366,
        "netallname": "上海农村商业银行股份有限公司昆山周市分理处",
        "netname": "昆山周市分理处",
        "publicconntel": "0512-36628960",
        "postcode": "215300",
        "address": "江苏省昆山市周市镇长江花园22号楼1-3室",
        "net_code": "32001",
        "province": "江苏省",
        "area": "昆山市",
        "location": {
            "lng": 120.9862646685741,
            "lat": 31.40778958600155
        }
    }
]